// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-29T18:33:38.109Z
// Property: Stephens Farm (ID: 6767906449167639)
// Collections: 11 amenities, 6 floorplans (live), 22 photos, 51 POIs, 5 reviews, 5 office hours, 1 special offers (live), 19 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162464",
  "multihub_property_id": "6767906449167639",
  "property_external_id": "1723630",
  "property_zillow_url": "https://www.zillow.com/apartments/holly-springs-nc/stephens-farm/CkY6jH/",
  "property_apartments_url": "https://www.apartments.com/stephens-farm-holly-springs-nc/37fl1dg/",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": "57156624034",
  "property_crm_software": "RentCafe Yardi",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "stephens-farm",
  "property_name": "Stephens Farm",
  "property_website_url": "https://www.stephensfarmhomes.com",
  "property_domain": "https://www.stephensfarmhomes.com",
  "property_address": "101 Peach Dahlia Road",
  "property_full_address": "101 Peach Dahlia Rd, Holly Springs, NC 27540",
  "property_address_1": "101 Peach Dahlia Road",
  "property_address_2": null,
  "property_address_city": "Holly Springs",
  "property_address_state": "NC",
  "property_address_zip_full": "27540",
  "property_address_zip": "27540",
  "property_address_country": "US",
  "property_address_county": "Wake County",
  "property_neighborhood_address": "Cary Crossroads/Apex",
  "property_address_latitude": "35.638123",
  "property_address_longitude": "-78.838589",
  "property_email": "quinley@quinnresidences-leasing.com",
  "property_phone": "(833) 365-8651",
  "property_call_tracking_phone": "877-385-4437",
  "property_company_name": "Quinn Residences",
  "property_company_url": "https://www.quinnmgmt.com",
  "agency_contacts": null,
  "property_type": "Townhomes",
  "property_short_description": "<p><strong>Modern townhome living with room to breathe.</strong> Explore spacious three- and four-bedroom rentals with polished finishes, smart home technology, in-unit laundry, and select fenced backyards or two-car garages—then find the floor plan that fits your next move.</p>",
  "property_long_description": "<p><strong>Modern townhome living with room to breathe.</strong> At Stephens Farm, you can choose spacious three- and four-bedroom rental homes that feel polished from the moment you walk in, with stainless steel appliances, granite countertops, luxury flooring, smart home technology, in-unit laundry, and select homes offering private fenced backyards and two-car garages.</p><p>Outside your door, the community keeps everyday living easy with a <a href=\"/amenities\">pool, dog park, playground, BBQ grills, lawn maintenance</a>, and a security deposit alternative. Explore <a href=\"/floor-plans\">flexible floor plans</a> with open living areas, generous closets, and finishes made for a streamlined routine.</p><p>Set in Holly Springs, Stephens Farm places you near the shopping and dining at Holly Springs Towne Center, outdoor time at Bass Lake Park and Sugg Farm’s trails and open space, and quick regional connections via NC 540 toward Apex, Cary, Raleigh-Durham International Airport, and the Research Triangle’s growing life-science corridor.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/01a183b1-5fd1-72a8-811d-171fb2452989.webp",
  "property_featured_image_media": {
    "alt_text": "Modern white kitchen with granite countertops and stainless steel appliances.",
    "public_id": "01a183b1-5fd1-72a8-811d-171fb2452989",
    "storage_key": "property/6767906449167639/01a183b1-5fd1-72a8-811d-171fb2452989.webp",
    "width": 2048,
    "height": 1536
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449167639/01a0c02b-50ac-70df-9f42-36fa393a6900.mp4",
  "property_featured_video_media": {
    "public_id": "01a0c02b-50ac-70df-9f42-36fa393a6900",
    "storage_key": "property/6767906449167639/01a0c02b-50ac-70df-9f42-36fa393a6900.mp4",
    "thumbnail_key": "property/6767906449167639/01a0c02b-50ac-70df-9f42-36fa393a6900_thumb.webp",
    "size_bytes": 25962849,
    "classification": "Community",
    "title": "Explore Our New Townhome Community with Resort-Style Amenities",
    "description": "Discover modern living in our vibrant townhome community. Featuring a sparkling pool, spacious park, and beautiful exteriors, this video offers a glimpse into the amenities and lifestyle."
  },
  "property_total_units": "292",
  "property_year_built": "2023",
  "property_year_renovated": null,
  "property_walk_score": "48",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.83561643835617",
  "property_admin_fee": "350",
  "property_application_fee": "100",
  "property_fees_deposit_info": "Security deposit varies with application screening; a security deposit alternative is available. Required monthly charges: utility billing $11.99, concierge $10.95, landscaping $45, smart home package $35; renters insurance required. Application fee $100 per adult applicant; administrative fee $350 (one-time). See the Easy Fee Guide for the full schedule.",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, and American Bulldog, or any crossbreeds of these. Maximum weight limit of 100 pounds per pet; no more than two pets without written approval. Pet screening is mandatory before move-in.",
  "property_pet_policy_description": "Dogs and cats welcome, up to two pets. One-time pet fee $300 for one pet, $500 for two. Pet rent $35 per pet per month. 100-lb weight limit and breed restrictions apply; pet screening is required before move-in.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://stephensfarmhomes.securecafe.com/onlineleasing/stephens-farm/floorplans.aspx",
  "property_resident_portal_url": "https://stephensfarmhomes.securecafenet.com/residentservices/stephens-farm/userlogin",
  "property_apply_now_url": "https://stephensfarmhomes.securecafe.com/onlineleasing/stephens-farm/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": null,
  "property_primary_logo_media": null,
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": null,
  "property_mono_white_logo_media": null,
  "property_mono_black_logo": null,
  "property_mono_black_logo_media": null,
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/01a0abc9-4cac-75ae-8a34-d20271f4bca8.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-2459-730d-9320-edaae039913a.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-24c1-74dc-8eb8-8eb0b71b3a84.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#276d39",
  "property_secondary_color": "#282827",
  "property_font_color": "#606161",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "3 - 4",
  "property_bedrooms_min": "3",
  "property_bedrooms_max": "4",
  "property_bathrooms_range": "2.5 - 3.5",
  "property_bathrooms_min": "2.5",
  "property_bathrooms_max": "3.5",
  "property_sqft_range": "1777 - 2497",
  "property_sqft_min": "1777",
  "property_sqft_max": "2497",
  "property_price_range": "2181 - 3169",
  "property_price_min": "2107",
  "property_price_max": "3074",
  "property_available_units": 18,
  "property_facebook_url": "https://www.facebook.com/profile.php?id=100089632043339",
  "property_instagram_url": "https://www.instagram.com/stephensfarmhomes/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJrYSK5OyRrIkREABY_ECwNWU",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Stephens Farm",
  "property_home_romance_title": "Experience the Joy of Living in Your Ideal Townhome",
  "property_home_amenities_blurb": "<p><strong>Low-maintenance comfort, polished for everyday living.</strong> Stephens Farm pairs lawn maintenance, smart-home features, in-unit laundry, and roomy closets with community spaces made for easy downtime. Swim at the pool, gather by the BBQ grills, or head to the dog park, then come home to stainless steel appliances, granite countertops, and luxury flooring in a townhome-style rental home.</p>",
  "property_home_floorplans_blurb": "<p><strong>Townhome-style space, polished for everyday ease.</strong> Explore three- and four-bedroom floor plans at Stephens Farm in Holly Springs, with open living areas, granite countertops, stainless steel appliances, smart-home technology, spacious closets, and in-unit laundry. Select layouts add a two-car garage and fenced backyard—giving you more room to settle into the plan that fits your next move.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture life in polished townhome-style rentals.</strong> Preview Stephens Farm’s bright kitchens with granite countertops and stainless steel appliances, open living areas with luxury flooring, roomy closets, in-unit laundry, and smart-home touches. Then step outside to sunny pool scenes, BBQ areas, maintained green lawns, a dog park, and a playground—all waiting in the full gallery.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Holly Springs, right on your route.</strong> Stephens Farm puts daily errands near SouthPark Village, local flavor close by at My Way Tavern, Pimiento Tea Room, and Nightingale Rooftop, and downtown Holly Springs just up NC 55. Spend free time at the Holly Springs Farmers Market, Cultural Center, or Womble Park’s trails, courts, fields, and bandshell—then reach Cary, Apex, Raleigh, and the Triangle with nearby highway connections.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents are talking about Stephens Farm.</strong> Reviews highlight responsive service, smooth move-ins, and modern townhomes that feel well cared for from day one. The team earns shoutouts for quick answers, helpful guidance, and maintenance that solves the issue—not just the symptom. Add spacious rooms, standout kitchens, everyday convenience, and an inviting neighborhood feel, and it’s easy to see why one reviewer called Stephens Farm a “breath of fresh air.”</p>",
  "property_neighborhood_blurb": "<p><strong>Put Holly Springs on your daily route.</strong> From Stephens Farm, you can keep errands close at SouthPark Village, follow NC 55 into downtown Holly Springs, or turn a free afternoon into dinner at local spots like My Way Tavern, Pimiento Tea Room, and Nightingale Rooftop.</p><p>The neighborhood balances everyday convenience with a strong sense of place: Saturday mornings at the Holly Springs Farmers Market, performances and events at the Cultural Center, and fresh air at Womble Park’s fields, courts, trails, and bandshell. When you want to look farther out, nearby highway connections keep Cary, Apex, Raleigh, and the broader Triangle within easy reach. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Stephens Farm connects you to it all.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that take work off your plate.</strong> At Stephens Farm, the details are designed to make your routine feel easier—from lawn maintenance outside to smart-home features, in-unit laundry, and roomy closets inside your townhome-style space.</p><p>Spend downtime at the pool, meet up by the BBQ grills, or give your pet a dedicated place to play at the dog park. Back home, stainless steel appliances, granite countertops, and luxury flooring create a clean, polished backdrop for cooking, relaxing, and hosting. Explore the <a href=\"/gallery\">amenity photos</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how these Holly Springs rental homes bring comfort, convenience, and low-maintenance living together.</p>",
  "property_applynow_blurb": "<p><strong>Start your application for Stephens Farm.</strong> Brand-new three- and four-bedroom townhomes in Holly Springs offer modern finishes, SMART-home technology, two-car garages, and private fenced-in backyards—plus lawn service for a maintenance-free lifestyle. Apply online today and take the next step toward calling Stephens Farm home.</p>",
  "property_contactus_blurb": "<p><strong>Have questions about Stephens Farm?</strong> Our leasing team is here to help with details on our brand-new three- and four-bedroom townhomes in Holly Springs, including smart-home features, fenced-in backyards, and maintenance-free lawn service. Contact us today for answers or directions to the community.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Stephens Farm?</strong> Start here. Explore FAQs about leasing, everyday living, and the modern details that make these pet-friendly Holly Springs townhomes stand out. If you need anything else, the <a href=\"/contact-us\">leasing team</a> is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Start with the space that fits how you live.</strong> Stephens Farm gives you a focused collection of three- and four-bedroom townhome-style floor plans in Holly Springs, from comfortable everyday layouts to larger plans with extra room to spread out. Compare designs like Lantana, Mandevilla, Honeysuckle, Moonflower, Veronica, and Winterberry to find the bedroom count, bath layout, and availability that make sense for your next move.</p><p>Inside, each plan pairs practical flow with polished finishes—think open living areas, granite countertops, stainless steel appliances, smart-home technology, spacious closets, and in-unit laundry. Select homes also offer the added ease of a two-car garage and fenced backyard. Browse current pricing and availability, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your preferred layout in person.</p>",
  "property_gallery_blurb": "<p><strong>See the details come into focus.</strong> Browse the Stephens Farm photo gallery for a closer look at polished townhome-style rentals in Holly Springs—from bright kitchens with granite countertops and stainless steel appliances to open living areas finished with luxury flooring and clean, modern lines. As you move through the images, picture daily routines unfolding around roomy closets, in-unit laundry, and smart-home touches that keep the space feeling streamlined.</p><p>Outside, the gallery captures the community’s easygoing spaces too: the pool on a sunny afternoon, BBQ areas ready for a casual meal, green lawns maintained for you, plus the dog park and playground woven into the neighborhood setting. Like what you see? Compare <a href=\"/floor-plans\">available floor plans</a>, explore <a href=\"/virtual-tours\">virtual tours</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience Stephens Farm in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Stephens Farm on the map.</strong> Find available three- and four-bedroom townhomes in Holly Springs, then see how the community’s modern, pet-friendly living fits your day-to-day. Start with <a href=\"/floor-plans\">available floor plans</a> and get a feel for the surrounding area.</p>",
  "property_pets_blurb": "<p><strong>Bring the leash, the treat bag, and the favorite sunny spot.</strong> At Stephens Farm, pet-friendly townhome living gives cats and dogs more than a place to stay—it supports the rhythm of everyday care. Start mornings with an easy loop along the walking and biking trails, head to the on-site dog park for fresh air, or choose a layout with a select fenced backyard for added outdoor convenience. Inside, spacious closets help keep pet gear organized, while polished flooring and smart-home touches make daily routines feel simple. When you want to see how your pet’s setup could work here in Holly Springs, explore the <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_referafriend_blurb": "<p><strong>Share modern living at Stephens Farm.</strong> Invite a friend to discover brand-new three- and four-bedroom townhomes in Holly Springs with two-car garages, fenced-in backyards, high-end finishes, SMART-home technology, and included lawn service for a maintenance-free lifestyle.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Stephens Farm</strong><br>Enjoy the ease of modern townhome living with quick online access to pay rent, submit maintenance requests, and manage your account—all in one convenient place.</p>",
  "property_reviews_blurb": "<p><strong>Real feedback from life at Stephens Farm.</strong> Residents consistently point to responsive service, well-kept modern townhomes, and a smooth move-in experience as highlights. Reviewers call out team members like Chelsea, Leif, Nitra, and Rashad for quick answers, helpful guidance, and maintenance that gets issues resolved—not just patched.</p><p>You’ll also see praise for spacious rooms, standout kitchens, an inviting neighborhood feel, and everyday convenience close by. One resident summed up the experience as a “breath of fresh air,” while another said the “service really shone.” Browse the reviews below to hear what residents value most about calling Stephens Farm home.</p>",
  "property_created_at": "1786373871023",
  "property_scheduletour_blurb": "<p><strong>See modern townhome living up close.</strong> Tour Stephens Farm in Holly Springs and explore brand-new three- and four-bedroom homes with two-car garages, fenced-in backyards, high-end finishes, SMART-home technology, and included lawn service. Schedule your visit today and picture the maintenance-free lifestyle in person.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong> The Stephens Farm leasing team will follow up soon. In the meantime, picture modern Holly Springs townhome living with three- and four-bedroom layouts, two-car garages, fenced-in backyards, high-end finishes, SMART-home technology, and lawn service for a maintenance-free lifestyle.</p>",
  "property_virtualtours_blurb": "<p><strong>Tour the layout, not just the listing.</strong> Walk through Stephens Farm’s virtual tours from wherever you are and get a room-to-room feel for the Honeysuckle, Moonflower, Lantana, Mandevilla, Winterberry, and Veronica layouts. These spacious three- and four-bedroom rental homes let you study the flow: open living areas, polished kitchens with granite countertops and stainless steel appliances, luxury flooring, smart-home touches, and closets you can actually picture using.</p><p>Use each walkthrough to compare sightlines, bedroom placement, and the everyday path from kitchen to living space before you narrow down your <a href=\"/floor-plans\">floor plan</a> options. Then browse the <a href=\"/gallery\">photo gallery</a> for more detail or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience Stephens Farm in Holly Springs in person.</p>",
  "property_copyright": "© 2026 Quinn Residences. All rights reserved.",
  "property_seo_title_home": "Stephens Farm |  Apartments in Holly Springs, NC",
  "property_seo_description_home": "Welcome to Stephens Farm in Holly Springs, NC! Luxury living with spacious floor plans, modern amenities, and a vibrant community. Find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | Holly Springs, NC Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Stephens Farm in Holly Springs, NC! Check out our diverse 3 & 4-bedroom floor plans for a perfect fit. Browse today!",
  "property_seo_title_amenities": "Amenities | Holly Springs, NC Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at Stephens Farm in Holly Springs, NC. Enjoy spacious apartments with modern amenities like a pool, dog park, and smart home tech.",
  "property_seo_title_gallery": "Gallery | Apartments in Holly Springs, NC",
  "property_seo_description_gallery": "Capture life at Stephens Farm in Holly Springs, NC. Stunning photo gallery showcasing luxury amenities, spacious homes, and a vibrant community awaits you!",
  "property_seo_title_virtualtours": "Virtual Tours | Stephens Farm Apartments",
  "property_seo_description_virtualtours": "Discover your dream home at Stephens Farm! Take a virtual tour of our spacious 3- and 4-bedroom apartments in Holly Springs, NC!",
  "property_seo_title_interactivemap": "Interactive Map | Stephens Farm Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Stephens Farm in Holly Springs, NC! Enjoy luxury living with top amenities and spacious floor plans. Use our interactive map today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Holly Springs, NC",
  "property_seo_description_neighborhood": "Uncover the charm of Holly Springs at Stephens Farm! Dive into local gems and attractions just steps away from your new home. Adventure awaits!",
  "property_seo_title_contact": "Contact Us | Stephens Farm",
  "property_seo_description_contact": "Find your perfect home at Stephens Farm in Holly Springs, NC. Inquire about our spacious 3- and 4-bedroom floor plans. Contact our leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Holly Springs, NC",
  "property_seo_description_faqs": "Find answers about life at Stephens Farm in Holly Springs, NC. Spacious floor plans, luxury amenities, and a community that feels like home await you!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Holly Springs, NC",
  "property_seo_description_reviews": "Experience life at Stephens Farm in Holly Springs, NC. Dive into resident reviews and discover spacious layouts, luxury amenities, and a vibrant community!",
  "property_seo_title_applynow": "Apply Now | Apartments in Holly Springs, NC",
  "property_seo_description_applynow": "Experience luxury living at Stephens Farm in Holly Springs, NC! Choose from spacious 3- or 4-bedroom layouts and enjoy top-notch amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Stephens Farm",
  "property_seo_description_residentaccess": "Stay connected at Stephens Farm, Holly Springs, NC! Log in to your resident portal for rent payments, maintenance requests, and updates.",
  "property_seo_title_referafriend": "Refer A Friend | Stephens Farm",
  "property_seo_description_referafriend": "Great friends make great neighbors at Stephens Farm! Refer a friend today and share the joy of living in our vibrant Holly Springs community!",
  "property_seo_title_scheduletour": "Schedule a Tour | Stephens Farm",
  "property_seo_description_scheduletour": "Experience the charm of Stephens Farm in Holly Springs, NC! Schedule a tour today and envision your new home in our vibrant, welcoming community.",
  "property_seo_title_privacy": "Privacy Policy | Stephens Farm",
  "property_seo_description_privacy": "At Stephens Farm in Holly Springs, NC, your privacy matters. Explore our commitment to protecting your information in our privacy policy!",
  "property_seo_title_accessibility": "Website Accessibility | Stephens Farm",
  "property_seo_description_accessibility": "At Stephens Farm in Holly Springs, we prioritize digital inclusion. Learn how our community embraces accessibility for all. Join us in fostering connection!",
  "property_seo_title_sitemap": "Sitemap | Stephens Farm",
  "property_seo_description_sitemap": "Uncover the charm of Stephens Farm in Holly Springs, NC. Dive into our sitemap for a complete guide to your future home and community features.",
  "property_seo_title_thankyou": "Thank You | Stephens Farm",
  "property_seo_description_thankyou": "Thank you for reaching out to Stephens Farm in Holly Springs! Our team will connect soon to help you find your perfect home in our vibrant community.",
  "property_seo_title_pets": "Pet Policy | Apartments in Holly Springs, NC",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793288568962",
  "amenities": [
    {
      "id": "ec_546fa57c18854358bf7d4397",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "yardi",
      "external_id": "121173417",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-8e01-7188-9b80-c0a66a264baa.webp",
      "amenity_image_media": {
        "alt_text": "A young girl in a pink swimsuit floats on a yellow tube in a bright blue swimming pool.",
        "public_id": "019fec2f-8e01-7188-9b80-c0a66a264baa",
        "storage_key": "property/6767906449167639/019fec2f-8e01-7188-9b80-c0a66a264baa.webp",
        "width": 856,
        "height": 615
      },
      "amenity_image_alt_text": "a little girl sitting on a float in a pool",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9c8eba1a364c983a284b642f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "yardi",
      "external_id": "121173418",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-8e06-715e-8257-e4ec02092f2b.webp",
      "amenity_image_media": {
        "alt_text": "Young boy on a playground.",
        "public_id": "019fec2f-8e06-715e-8257-e4ec02092f2b",
        "storage_key": "property/6767906449167639/019fec2f-8e06-715e-8257-e4ec02092f2b.webp",
        "width": 856,
        "height": 615
      },
      "amenity_image_alt_text": "a young boy playing on a playground slide",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b05f88326263696bae41025e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "yardi",
      "external_id": "121173420",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-8f7b-7221-a04f-5376e4a5fbcc.webp",
      "amenity_image_media": {
        "alt_text": "A man and a woman sitting on a sofa, looking at a laptop.",
        "public_id": "019fec2f-8f7b-7221-a04f-5376e4a5fbcc",
        "storage_key": "property/6767906449167639/019fec2f-8f7b-7221-a04f-5376e4a5fbcc.webp",
        "width": 856,
        "height": 615
      },
      "amenity_image_alt_text": "a man and a woman sitting on a couch looking at a laptop computer",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c2334b2c2f92b3acec5c529f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "yardi",
      "external_id": "121173421",
      "title": "BBQ Grills",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-8e08-706a-8eb4-d380f356fbc9.webp",
      "amenity_image_media": {
        "alt_text": "People enjoying a summer barbecue with grilled food and skewers on a grassy lawn.",
        "public_id": "019fec2f-8e08-706a-8eb4-d380f356fbc9",
        "storage_key": "property/6767906449167639/019fec2f-8e08-706a-8eb4-d380f356fbc9.webp",
        "width": 856,
        "height": 615
      },
      "amenity_image_alt_text": "a group of people are gathered around a grill with food on it",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e19130b9eeda5f3f2acaa899",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "yardi",
      "external_id": "121173412",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-992b-77fc-aaed-62c8baff85fc.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and white cabinets.",
        "public_id": "019fec2f-992b-77fc-aaed-62c8baff85fc",
        "storage_key": "property/6767906449167639/019fec2f-992b-77fc-aaed-62c8baff85fc.webp",
        "width": 856,
        "height": 616
      },
      "amenity_image_alt_text": "a kitchen with a granite counter top and a stainless steel refrigerator",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8e2b2c8cc9a94024dc3ce362",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "yardi",
      "external_id": "121173415",
      "title": "Spacious Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-9990-704d-b5a9-156326f9827f.webp",
      "amenity_image_media": {
        "alt_text": "Spacious walk-in closet with white wire shelving.",
        "public_id": "019fec2f-9990-704d-b5a9-156326f9827f",
        "storage_key": "property/6767906449167639/019fec2f-9990-704d-b5a9-156326f9827f.webp",
        "width": 856,
        "height": 616
      },
      "amenity_image_alt_text": "a mirrored walk in closet with empty shelves",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_883a825e868981e403a637ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "yardi",
      "external_id": "121173413",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-9ba3-702d-8575-ab97620b1086.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen island with granite countertop, double sink, and faucet, stainless steel refrigerator in background.",
        "public_id": "019fec2f-9ba3-702d-8575-ab97620b1086",
        "storage_key": "property/6767906449167639/019fec2f-9ba3-702d-8575-ab97620b1086.webp",
        "width": 856,
        "height": 616
      },
      "amenity_image_alt_text": "a kitchen with a granite counter top and a sink",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1c071819c6172c8435ed23c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "yardi",
      "external_id": "121173419",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-8e4e-71ad-ac37-699851940d55.webp",
      "amenity_image_media": {
        "alt_text": "A beagle jumps in a grassy yard with a colorful rope toy in its mouth.",
        "public_id": "019fec2f-8e4e-71ad-ac37-699851940d55",
        "storage_key": "property/6767906449167639/019fec2f-8e4e-71ad-ac37-699851940d55.webp",
        "width": 856,
        "height": 615
      },
      "amenity_image_alt_text": "a small brown and white dog running with a toy in its mouth",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1132735d8becff91eabdf488",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "yardi",
      "external_id": "121173414",
      "title": "Luxury Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-a186-75d6-be85-a08d8ae969f6.webp",
      "amenity_image_media": {
        "alt_text": "Spacious open-concept living area with a modern kitchen island and stainless steel appliances.",
        "public_id": "019fec2f-a186-75d6-be85-a08d8ae969f6",
        "storage_key": "property/6767906449167639/019fec2f-a186-75d6-be85-a08d8ae969f6.webp",
        "width": 856,
        "height": 616
      },
      "amenity_image_alt_text": "an open kitchen and living room with a large",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_80dd415975d5448da7ee9cfd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "yardi",
      "external_id": "121173416",
      "title": "Smart Home Technology",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-a111-74ef-a90c-8297024461c0.webp",
      "amenity_image_media": {
        "alt_text": "Close-up of a hand adjusting a smart thermostat set to 72 degrees.",
        "public_id": "019fec2f-a111-74ef-a90c-8297024461c0",
        "storage_key": "property/6767906449167639/019fec2f-a111-74ef-a90c-8297024461c0.webp",
        "width": 856,
        "height": 615
      },
      "amenity_image_alt_text": "a person pointing to a thermostat on a wall",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ba89be9b5cc66a334d81aea3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "yardi",
      "external_id": "121173422",
      "title": "Lawn Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2f-97b7-75c1-adf5-a8ca91d434cf.webp",
      "amenity_image_media": {
        "alt_text": "Lawn mower cutting grass in a landscaped yard",
        "public_id": "019fec2f-97b7-75c1-adf5-a8ca91d434cf",
        "storage_key": "property/6767906449167639/019fec2f-97b7-75c1-adf5-a8ca91d434cf.webp",
        "width": 856,
        "height": 616
      },
      "amenity_image_alt_text": "a lawn mower is parked in the grass",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_dfd31621c1f3ecc8d39cd7b4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/01a183b1-5fd1-72a8-811d-171fb2452989.webp",
      "image_media": {
        "alt_text": "Modern white kitchen with granite countertops and stainless steel appliances.",
        "public_id": "01a183b1-5fd1-72a8-811d-171fb2452989",
        "storage_key": "property/6767906449167639/01a183b1-5fd1-72a8-811d-171fb2452989.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Spacious and bright modern kitchen featuring white cabinetry, granite countertops, stainless steel appliances, and a central island with a sink.",
      "link": "false",
      "alt_text": "Modern white kitchen with granite countertops and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/10-web-or-mls-118%20Double%20Tulip%20Drive-S2908-010.jpg"
    },
    {
      "id": "ec_2ea3b857a52215991835cf92",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/01a183b1-7788-732a-bbc4-a0a6fc1b0d6b.webp",
      "image_media": {
        "alt_text": "Exterior of a modern townhouse with brick and siding.",
        "public_id": "01a183b1-7788-732a-bbc4-a0a6fc1b0d6b",
        "storage_key": "property/6767906449167639/01a183b1-7788-732a-bbc4-a0a6fc1b0d6b.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Community",
      "description": "Facade of a beautiful townhouse with brick and siding. Features multiple garages and large windows, with a clear blue sky above.",
      "link": "false",
      "alt_text": "Exterior of a modern townhouse with brick and siding.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/1-web-or-mls-118%20Double%20Tulip%20Drive-S2908-001.jpg"
    },
    {
      "id": "ec_1a69b4cd7709d0d4102dd9b3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/01a183b1-7791-771a-ae60-b9d9c615d488.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a gas stove.",
        "public_id": "01a183b1-7791-771a-ae60-b9d9c615d488",
        "storage_key": "property/6767906449167639/01a183b1-7791-771a-ae60-b9d9c615d488.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed kitchen, featuring sleek white cabinetry, durable granite countertops, and a full suite of stainless steel appliances, perfect for any home chef.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a gas stove.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/13-web-or-mls-118%20Double%20Tulip%20Drive-S2908-013.jpg"
    },
    {
      "id": "ec_1508524b8630db1671cd1431",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/01a183b1-7bf4-72fb-a0d7-8a7a2679d236.webp",
      "image_media": {
        "alt_text": "Spacious living room and kitchen area with modern appliances and furniture.",
        "public_id": "01a183b1-7bf4-72fb-a0d7-8a7a2679d236",
        "storage_key": "property/6767906449167639/01a183b1-7bf4-72fb-a0d7-8a7a2679d236.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Enjoy an open-concept living and dining area, perfect for entertaining guests. The modern kitchen features ample counter space and stainless steel appliances.",
      "link": "false",
      "alt_text": "Spacious living room and kitchen area with modern appliances and furniture.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/6-web-or-mls-118%20Double%20Tulip%20Drive-S2908-006.jpg"
    },
    {
      "id": "ec_f9e09c04e179e2860a529421",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/01a183b1-778f-7039-bd70-5ec732933539.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with granite countertops and stainless steel appliances.",
        "public_id": "01a183b1-778f-7039-bd70-5ec732933539",
        "storage_key": "property/6767906449167639/01a183b1-778f-7039-bd70-5ec732933539.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring a large island with a sink and dishwasher, perfect for meal prep and entertaining.",
      "link": "false",
      "alt_text": "A kitchen with white cabinets and a granite countertop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/12-web-or-mls-118%20Double%20Tulip%20Drive-S2908-012.jpg"
    },
    {
      "id": "ec_a6a54154c83f56549d85ffa6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/01a183b1-7791-771a-ae60-bc729b8480b9.webp",
      "image_media": {
        "alt_text": "Dining area with a table, chairs, and access to the outdoors.",
        "public_id": "01a183b1-7791-771a-ae60-bc729b8480b9",
        "storage_key": "property/6767906449167639/01a183b1-7791-771a-ae60-bc729b8480b9.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Enjoy meals in this bright dining area, featuring a stylish table and chairs with convenient access to your outdoor space.",
      "link": "false",
      "alt_text": "A dining room with a table and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/8-web-or-mls-118%20Double%20Tulip%20Drive-S2908-008.jpg"
    },
    {
      "id": "ec_498a5e86a47119f4f83e998a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/01a183b1-89fe-776d-a03d-bcce0d7f1c97.webp",
      "image_media": {
        "alt_text": "Modern home office with a wooden desk, yellow chair, and built-in white cabinets.",
        "public_id": "01a183b1-89fe-776d-a03d-bcce0d7f1c97",
        "storage_key": "property/6767906449167639/01a183b1-89fe-776d-a03d-bcce0d7f1c97.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Create your ideal workspace in this modern home office, featuring a comfortable desk, ergonomic chair, and ample storage with sleek white cabinetry.",
      "link": "false",
      "alt_text": "A room with a desk and a chair in it.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/16-web-or-mls-118%20Double%20Tulip%20Drive-S2908-016.jpg"
    },
    {
      "id": "ec_e09edd6750f4686257200ad4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/01a183b1-895e-76cd-a779-634bd25c2637.webp",
      "image_media": {
        "alt_text": "Interior hallway with staircase and front door.",
        "public_id": "01a183b1-895e-76cd-a779-634bd25c2637",
        "storage_key": "property/6767906449167639/01a183b1-895e-76cd-a779-634bd25c2637.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Step into a welcoming interior hallway featuring a sleek staircase and a bright front door, creating an inviting entryway to your new apartment home.",
      "link": "false",
      "alt_text": "A hallway with a staircase and a door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/4-web-or-mls-118%20Double%20Tulip%20Drive-S2908-004.jpg"
    },
    {
      "id": "ec_c45ebcded7d59affe555c13b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/01a183b1-8944-741f-8ab6-e4d7e5560863.webp",
      "image_media": {
        "alt_text": "Dining area with a table and chairs in a modern apartment.",
        "public_id": "01a183b1-8944-741f-8ab6-e4d7e5560863",
        "storage_key": "property/6767906449167639/01a183b1-8944-741f-8ab6-e4d7e5560863.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Enjoy meals in your stylish dining area, perfect for intimate gatherings or everyday dining.",
      "link": "false",
      "alt_text": "Dining area with a table and chairs in a modern apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/9-web-or-mls-118%20Double%20Tulip%20Drive-S2908-009.jpg"
    },
    {
      "id": "ec_c397f2b60d7c349e4caf8741",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/01a183b1-8a35-71e5-809c-44d0cac01192.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstands, and three windows.",
        "public_id": "01a183b1-8a35-71e5-809c-44d0cac01192",
        "storage_key": "property/6767906449167639/01a183b1-8a35-71e5-809c-44d0cac01192.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-size bed with a wooden headboard, two matching nightstands with lamps, and large windows that let in plenty of natural light. The room has a neutral color palette and wood-look flooring.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, nightstands, and three windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/17-web-or-mls-118%20Double%20Tulip%20Drive-S2908-017.jpg"
    },
    {
      "id": "ec_4551ace09be7fabbef2f01b6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/01a183b1-8e40-75ed-91a6-abe50f80854c.webp",
      "image_media": {
        "alt_text": "Bedroom with a dresser, mirror, and bed, leading to a kitchen area.",
        "public_id": "01a183b1-8e40-75ed-91a6-abe50f80854c",
        "storage_key": "property/6767906449167639/01a183b1-8e40-75ed-91a6-abe50f80854c.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a dresser and mirror, with a view into the kitchen and closet space. Perfect for relaxation and comfort.",
      "link": "false",
      "alt_text": "Bedroom with a dresser, mirror, and bed, leading to a kitchen area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/18-web-or-mls-118%20Double%20Tulip%20Drive-S2908-018.jpg"
    },
    {
      "id": "ec_518356d825e48a32b5fd7bba",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/01a183b1-994b-728e-b384-6259adc229ac.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, walk-in shower, and large mirror.",
        "public_id": "01a183b1-994b-728e-b384-6259adc229ac",
        "storage_key": "property/6767906449167639/01a183b1-994b-728e-b384-6259adc229ac.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this elegant bathroom, featuring a spacious double vanity, a sleek walk-in shower, and a generous mirror for a bright, open feel.",
      "link": "false",
      "alt_text": "A bathroom with a white sink, mirror, and cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/20-web-or-mls-118%20Double%20Tulip%20Drive-S2908-020.jpg"
    },
    {
      "id": "ec_03d2d259eafa630fa3c48067",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/01a183b1-9a11-72ca-8627-56eb4dcf8dd6.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with white wire shelving and wood-look flooring.",
        "public_id": "01a183b1-9a11-72ca-8627-56eb4dcf8dd6",
        "storage_key": "property/6767906449167639/01a183b1-9a11-72ca-8627-56eb4dcf8dd6.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample white wire shelving provides plenty of storage space for your belongings. The modern wood-look flooring adds a touch of style.",
      "link": "false",
      "alt_text": "Empty room with white walls and wooden floor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/19-web-or-mls-118%20Double%20Tulip%20Drive-S2908-019.jpg"
    },
    {
      "id": "ec_3b259a236fa2fb3d77adf749",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/01a183b1-99f9-7348-80b5-beeda3754e88.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, dresser, and two windows.",
        "public_id": "01a183b1-99f9-7348-80b5-beeda3754e88",
        "storage_key": "property/6767906449167639/01a183b1-99f9-7348-80b5-beeda3754e88.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a queen-size bed with decorative pillows, a modern dresser, and large windows allowing natural light.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, dresser, and two windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/22-web-or-mls-118%20Double%20Tulip%20Drive-S2908-022.jpg"
    },
    {
      "id": "ec_646f7409264f032e51b76d9a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/01a183b1-9b29-7118-b590-02fc3b15a3ce.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, and dresser.",
        "public_id": "01a183b1-9b29-7118-b590-02fc3b15a3ce",
        "storage_key": "property/6767906449167639/01a183b1-9b29-7118-b590-02fc3b15a3ce.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Apartment",
      "description": "A comfortable bedroom featuring a queen-size bed, a modern nightstand, and a dresser. The room has neutral walls and wood-look flooring.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, nightstand, and dresser.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/23-web-or-mls-118%20Double%20Tulip%20Drive-S2908-023.jpg"
    },
    {
      "id": "ec_b883a7d1e5e077bb16f04aaa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/01a183b1-9db5-7391-9356-284f68a3b965.webp",
      "image_media": {
        "alt_text": "White bathtub and shower with a leafy green towel hanging on a silver rack.",
        "public_id": "01a183b1-9db5-7391-9356-284f68a3b965",
        "storage_key": "property/6767906449167639/01a183b1-9db5-7391-9356-284f68a3b965.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Enjoy a relaxing soak in the clean and modern bathtub, featuring a showerhead and tiled walls. A decorative green towel adds a touch of style.",
      "link": "false",
      "alt_text": "White bathtub and shower with a leafy green towel hanging on a silver rack.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/26-web-or-mls-118%20Double%20Tulip%20Drive-S2908-026.jpg"
    },
    {
      "id": "ec_6b16e855bd985b20a09c94c6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/01a183b1-a730-74bd-bda9-3fcd20daee41.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, large mirror, and tiled shower/tub combo.",
        "public_id": "01a183b1-a730-74bd-bda9-3fcd20daee41",
        "storage_key": "property/6767906449167639/01a183b1-a730-74bd-bda9-3fcd20daee41.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Enjoy the clean and bright design of this modern bathroom, featuring a spacious vanity, a large mirror, and a classic tiled shower and tub combination.",
      "link": "false",
      "alt_text": "Modern bathroom with white vanity, large mirror, and tiled shower/tub combo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/25-web-or-mls-118%20Double%20Tulip%20Drive-S2908-025.jpg"
    },
    {
      "id": "ec_71f6cfc4d4bdfb81e1747875",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/01a183b1-a894-7688-8f7e-f611894a1c7e.webp",
      "image_media": {
        "alt_text": "A child's bedroom with a pink bed, nightstand, and dresser.",
        "public_id": "01a183b1-a894-7688-8f7e-f611894a1c7e",
        "storage_key": "property/6767906449167639/01a183b1-a894-7688-8f7e-f611894a1c7e.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Cozy and bright child's bedroom featuring a comfortable bed with pink bedding, a dark wood nightstand, and a dresser. The room is decorated with a colorful abstract art piece and large windows that let in natural light.",
      "link": "false",
      "alt_text": "A child's bedroom with a pink bed, nightstand, and dresser.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/27-web-or-mls-118%20Double%20Tulip%20Drive-S2908-027.jpg"
    },
    {
      "id": "ec_c68ce43c30d9fcbf6c0d52bd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/01a183b1-acf8-7048-b503-9be847259183.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer",
        "public_id": "01a183b1-acf8-7048-b503-9be847259183",
        "storage_key": "property/6767906449167639/01a183b1-acf8-7048-b503-9be847259183.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer for your laundry needs.",
      "link": "false",
      "alt_text": "In-unit washer and dryer",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/24-web-or-mls-118%20Double%20Tulip%20Drive-S2908-024.jpg"
    },
    {
      "id": "ec_c8745184e149bb902c5917ee",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/01a183b1-aa9d-74fd-b452-91139d177f13.webp",
      "image_media": {
        "alt_text": "Exterior view of townhomes with brick accents and attached garages.",
        "public_id": "01a183b1-aa9d-74fd-b452-91139d177f13",
        "storage_key": "property/6767906449167639/01a183b1-aa9d-74fd-b452-91139d177f13.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Community",
      "description": "Stunning exterior of these townhomes, featuring classic brickwork, modern siding, and convenient attached garages for easy living.",
      "link": "false",
      "alt_text": "A modern two-story house with a garage and a driveway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/33-web-or-mls-118%20Double%20Tulip%20Drive-S2908-033.jpg"
    },
    {
      "id": "ec_3f9525d79c0da86ee823624a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/01a183b1-ae5e-7083-b67e-cf290be384c5.webp",
      "image_media": {
        "alt_text": "Aerial view of a residential community with townhouses, a swimming pool, and green spaces.",
        "public_id": "01a183b1-ae5e-7083-b67e-cf290be384c5",
        "storage_key": "property/6767906449167639/01a183b1-ae5e-7083-b67e-cf290be384c5.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Community",
      "description": "Experience modern living in this vibrant community, featuring stylish townhomes, a refreshing swimming pool, and beautifully landscaped green spaces. Enjoy resort-style amenities and a welcoming neighborhood atmosphere.",
      "link": "false",
      "alt_text": "Aerial view of a residential community with townhouses, a swimming pool, and green spaces.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/45-web-or-mls-118%20Double%20Tulip%20Drive-S2908-045.jpg"
    },
    {
      "id": "ec_a9fb64833bd40107977da0cc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/01a183b1-b671-76e2-bb16-cbe0ab9ff60e.webp",
      "image_media": {
        "alt_text": "Aerial view of a neighborhood with townhouses and surrounding trees.",
        "public_id": "01a183b1-b671-76e2-bb16-cbe0ab9ff60e",
        "storage_key": "property/6767906449167639/01a183b1-b671-76e2-bb16-cbe0ab9ff60e.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Community",
      "description": "An aerial view showcases a charming neighborhood filled with townhouses and lush green trees, creating a picturesque residential setting.",
      "link": "false",
      "alt_text": "Aerial view of a neighborhood with townhouses and surrounding trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/35-web-or-mls-118%20Double%20Tulip%20Drive-S2908-035.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_03afb4c6-f6fb-4d05-b571-c112ee2a6e31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Pimiento Tea Room",
      "poi_type": "Restaurants",
      "poi_address": "200 N Main St, Holly Springs, NC 27540, USA",
      "poi_short_description": "Craft cocktails, beer, and a rotating menu of Southern-inspired dishes offered in a historic home.",
      "poi_long_description": "Craft cocktails, beer, and a rotating menu of Southern-inspired dishes offered in a historic home.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-76ce-722a-86a4-ad6a438e8d37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-76ce-722a-86a4-ad6a438e8d37",
        "storage_key": "property/6767906449167639/019fec31-76ce-722a-86a4-ad6a438e8d37.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.pimientotearoom.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13671970369681231459",
      "poi_item_slug": "pimiento-tea-room",
      "poi_latitude": "35.6532632",
      "poi_longitude": "-78.833585",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 984-225-4213",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4457-72e8-be6d-292f42765eb7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4457-72e8-be6d-292f42765eb7",
        "storage_key": "property/6767906449167639/019fec2e-4457-72e8-be6d-292f42765eb7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFZgs3nWPrIkRYw6EMJ2YvL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_9c96dc6a-f21b-4677-a670-def241e1fc52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Nightingale Rooftop Restaurant & Bar",
      "poi_type": "Restaurants",
      "poi_address": "300 S Main St Suite 312, Holly Springs, NC 27540, USA",
      "poi_short_description": "Rooftop restaurant and bar on South Main Street in downtown Holly Springs.",
      "poi_long_description": "Rooftop restaurant and bar on South Main Street in downtown Holly Springs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-79a3-764a-a8fc-d057fea3be84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-79a3-764a-a8fc-d057fea3be84",
        "storage_key": "property/6767906449167639/019fec31-79a3-764a-a8fc-d057fea3be84.webp",
        "width": 1280,
        "height": 886
      },
      "poi_business_url": "https://www.nightingalerooftop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10782815378333086319",
      "poi_item_slug": "nightingale-rooftop-restaurant--bar",
      "poi_latitude": "35.6483012",
      "poi_longitude": "-78.8338149",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 919-299-2004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4457-72e8-be6d-292f42765eb7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4457-72e8-be6d-292f42765eb7",
        "storage_key": "property/6767906449167639/019fec2e-4457-72e8-be6d-292f42765eb7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIdVUWuGPrIkRb7Ip8HRBpJU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_f61816a6-2218-4a31-8ffc-68162a0f1ca9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Vieni Ristobar",
      "poi_type": "Restaurants",
      "poi_address": "242 S Main St Suite112, Holly Springs, NC 27540, USA",
      "poi_short_description": "Informal, kid-friendly operation with an extensive menu of homestyle Italian plates.",
      "poi_long_description": "Informal, kid-friendly operation with an extensive menu of homestyle Italian plates.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-7047-753a-8ada-df7a5f4cf22b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-7047-753a-8ada-df7a5f4cf22b",
        "storage_key": "property/6767906449167639/019fec31-7047-753a-8ada-df7a5f4cf22b.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://vieniristobar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11075545956405020324",
      "poi_item_slug": "vieni-ristobar",
      "poi_latitude": "35.6490325",
      "poi_longitude": "-78.8339385",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 984-225-1134",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4457-72e8-be6d-292f42765eb7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4457-72e8-be6d-292f42765eb7",
        "storage_key": "property/6767906449167639/019fec2e-4457-72e8-be6d-292f42765eb7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL2e8I5iPrIkRpAYJ2V0-tJk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_86f799d3-c393-4707-b78a-f2244c6e23e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Osha Thai Kitchen and Sushi",
      "poi_type": "Restaurants",
      "poi_address": "242 S Main St #100, Holly Springs, NC 27540, USA",
      "poi_short_description": "Thai restaurant serving sushi and curries in a modern, spacious venue.",
      "poi_long_description": "Thai restaurant serving sushi and curries in a modern, spacious venue.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-22e3-741b-8a30-415979287fc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2e-22e3-741b-8a30-415979287fc3",
        "storage_key": "property/6767906449167639/019fec2e-22e3-741b-8a30-415979287fc3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://oshathaikitchennc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1187494623784541899",
      "poi_item_slug": "osha-thai-kitchen-and-sushi",
      "poi_latitude": "35.64952299999999",
      "poi_longitude": "-78.83388839999999",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 984-538-6742",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4457-72e8-be6d-292f42765eb7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4457-72e8-be6d-292f42765eb7",
        "storage_key": "property/6767906449167639/019fec2e-4457-72e8-be6d-292f42765eb7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwY_MeAyPrIkRyx5dlxHUehA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_fbf83637-48d7-44bb-ac5a-a19358c0d052",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "smashed - Burgers & Cocktails",
      "poi_type": "Restaurants",
      "poi_address": "242 S Main St #118, Holly Springs, NC 27540, USA",
      "poi_short_description": "Relaxed, family-friendly joint offering smash burgers and drinks, alongside vegetarian options.",
      "poi_long_description": "Relaxed, family-friendly joint offering smash burgers and drinks, alongside vegetarian options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-6f25-749c-9829-ddf9d92baeaf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-6f25-749c-9829-ddf9d92baeaf",
        "storage_key": "property/6767906449167639/019fec31-6f25-749c-9829-ddf9d92baeaf.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "http://www.smashednc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6417370922121187719",
      "poi_item_slug": "smashed---burgers--cocktails",
      "poi_latitude": "35.6487321",
      "poi_longitude": "-78.8338311",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 919-390-2274",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4457-72e8-be6d-292f42765eb7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4457-72e8-be6d-292f42765eb7",
        "storage_key": "property/6767906449167639/019fec2e-4457-72e8-be6d-292f42765eb7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLb2CL2-PrIkRh1H0XNoUD1k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_8e82e318-f037-44cc-a4b1-750341ed3ebd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Five Star Coffee Roasters",
      "poi_type": "Restaurants",
      "poi_address": "108 Thomas Mill Rd #101, Holly Springs, NC 27540, USA",
      "poi_short_description": "Local coffee roaster and café on Thomas Mill Road.",
      "poi_long_description": "Local coffee roaster and café on Thomas Mill Road.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-7283-72cc-9cfc-75c22eb6faa2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-7283-72cc-9cfc-75c22eb6faa2",
        "storage_key": "property/6767906449167639/019fec31-7283-72cc-9cfc-75c22eb6faa2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://5starcoffeeroasters.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18419076859986030249",
      "poi_item_slug": "five-star-coffee-roasters",
      "poi_latitude": "35.6561878",
      "poi_longitude": "-78.8523228",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 919-671-0645",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4450-749b-b4f2-f5c4793db3c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4450-749b-b4f2-f5c4793db3c8",
        "storage_key": "property/6767906449167639/019fec2e-4450-749b-b4f2-f5c4793db3c8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLUxftfeRrIkRqa4V0tC0nf8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_roastery"
    },
    {
      "id": "custom_0493fa9b-0461-4085-bed4-99e69c852110",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "The Blind Pelican Seafood House",
      "poi_type": "Restaurants",
      "poi_address": "120 Bass Lake Rd, Holly Springs, NC 27540, USA",
      "poi_short_description": "Upscale-casual spot for fresh seafood dishes such as sushi nachos and lobster rolls, as well as cocktails.",
      "poi_long_description": "Upscale-casual spot for fresh seafood dishes such as sushi nachos and lobster rolls, as well as cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-233c-722f-9912-0ea2070d75ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2e-233c-722f-9912-0ea2070d75ff",
        "storage_key": "property/6767906449167639/019fec2e-233c-722f-9912-0ea2070d75ff.webp",
        "width": 1280,
        "height": 754
      },
      "poi_business_url": "http://www.blindpelicanseafood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5466147203163522486",
      "poi_item_slug": "the-blind-pelican-seafood-house",
      "poi_latitude": "35.6532456",
      "poi_longitude": "-78.8247998",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 984-225-2471",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4457-72e8-be6d-292f42765eb7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4457-72e8-be6d-292f42765eb7",
        "storage_key": "property/6767906449167639/019fec2e-4457-72e8-be6d-292f42765eb7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsfYoKUWPrIkRtoWOnuun20s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_a7a1cc14-04ac-43a9-b278-8e3db2d20f76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Bass Lake Draft House",
      "poi_type": "Restaurants",
      "poi_address": "124 Bass Lake Rd, Holly Springs, NC 27540, USA",
      "poi_short_description": "Family-friendly pub offering 30-some draft beers along with comfort-food eats & TV sports.",
      "poi_long_description": "Family-friendly pub offering 30-some draft beers along with comfort-food eats & TV sports.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-7101-709e-9059-2b9bc52466ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-7101-709e-9059-2b9bc52466ca",
        "storage_key": "property/6767906449167639/019fec31-7101-709e-9059-2b9bc52466ca.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://basslakedrafthouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6950524326714486838",
      "poi_item_slug": "bass-lake-draft-house",
      "poi_latitude": "35.6530639",
      "poi_longitude": "-78.8239722",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 919-567-3251",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4457-72e8-be6d-292f42765eb7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4457-72e8-be6d-292f42765eb7",
        "storage_key": "property/6767906449167639/019fec2e-4457-72e8-be6d-292f42765eb7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEe3oywmOrIkRNjCHuAw5dWA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_be303bd1-abc6-4112-9e1a-2f42b42a2046",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Hickory Tavern",
      "poi_type": "Restaurants",
      "poi_address": "401 Village Walk Dr Unit A, Holly Springs, NC 27540, USA",
      "poi_short_description": "Sports bar & grill chain with an extensive menu of typical bar food & TVs galore.",
      "poi_long_description": "Sports bar & grill chain with an extensive menu of typical bar food & TVs galore.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-7804-711f-b288-781e968082f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-7804-711f-b288-781e968082f5",
        "storage_key": "property/6767906449167639/019fec31-7804-711f-b288-781e968082f5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.thehickorytavern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=865363152267319373",
      "poi_item_slug": "hickory-tavern",
      "poi_latitude": "35.6405653",
      "poi_longitude": "-78.83748530000001",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 919-557-2064",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4457-72e8-be6d-292f42765eb7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4457-72e8-be6d-292f42765eb7",
        "storage_key": "property/6767906449167639/019fec2e-4457-72e8-be6d-292f42765eb7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ36DJ_x2OrIkRTRibvDNjAgw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_1502d5f1-7557-49f1-bbde-dd1bc190c262",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "My Way Tavern",
      "poi_type": "Restaurants",
      "poi_address": "301 Center St, Holly Springs, NC 27540, USA",
      "poi_short_description": "Relaxed hangout featuring a large beer selection, pub eats, and live entertainment, plus TV sports.",
      "poi_long_description": "Relaxed hangout featuring a large beer selection, pub eats, and live entertainment, plus TV sports.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-7626-74da-9fa5-4607c777f457.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-7626-74da-9fa5-4607c777f457",
        "storage_key": "property/6767906449167639/019fec31-7626-74da-9fa5-4607c777f457.webp",
        "width": 535,
        "height": 395
      },
      "poi_business_url": "http://www.mywaytavern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8272026604928209411",
      "poi_item_slug": "my-way-tavern",
      "poi_latitude": "35.6511103",
      "poi_longitude": "-78.8341082",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 919-285-2412",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4457-72e8-be6d-292f42765eb7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4457-72e8-be6d-292f42765eb7",
        "storage_key": "property/6767906449167639/019fec2e-4457-72e8-be6d-292f42765eb7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLa4wZwGOrIkRA5JTv14kzHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_b81f2c42-d790-49c0-9fb3-27c66a7a733d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Lowes Foods of Holly Springs",
      "poi_type": "Shopping & Retail",
      "poi_address": "112 Bass Lake Rd, Holly Springs, NC 27540, USA",
      "poi_short_description": "Supermarket chain known for chicken prepared on-site, plus pantry staples, produce, bakery & more.",
      "poi_long_description": "Supermarket chain known for chicken prepared on-site, plus pantry staples, produce, bakery & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-7ac2-76fa-95b7-5ed973571188.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-7ac2-76fa-95b7-5ed973571188",
        "storage_key": "property/6767906449167639/019fec31-7ac2-76fa-95b7-5ed973571188.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "http://www.lowesfoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10855301248773020856",
      "poi_item_slug": "lowes-foods-of-holly-springs",
      "poi_latitude": "35.6537868",
      "poi_longitude": "-78.8250661",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 919-577-6971",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4486-75ac-91e0-075a23179115.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4486-75ac-91e0-075a23179115",
        "storage_key": "property/6767906449167639/019fec2e-4486-75ac-91e0-075a23179115.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjbH8ywmOrIkRuFz4zvjGpZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b2b637ff-162e-473b-a1de-5067f71e4332",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Food Lion",
      "poi_type": "Shopping & Retail",
      "poi_address": "517 N Main St, Holly Springs, NC 27540, USA",
      "poi_short_description": "Grocery store offering bulk foods, organic products, and prepared items, plus a help desk.",
      "poi_long_description": "Grocery store offering bulk foods, organic products, and prepared items, plus a help desk.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-81be-7518-939d-a3726a860f59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-81be-7518-939d-a3726a860f59",
        "storage_key": "property/6767906449167639/019fec31-81be-7518-939d-a3726a860f59.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://stores.foodlion.com/nc/holly-springs/517-n-main-st?y_source=1_NTA0NjQ2OS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10736536843650089085",
      "poi_item_slug": "food-lion",
      "poi_latitude": "35.659761",
      "poi_longitude": "-78.83720400000001",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 919-557-1175",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4486-75ac-91e0-075a23179115.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4486-75ac-91e0-075a23179115",
        "storage_key": "property/6767906449167639/019fec2e-4486-75ac-91e0-075a23179115.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuzKkTf6NrIkRfUCo61_X_5Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_e9574e0b-d908-4ea0-99bc-8d6a1ef239aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "7400 GB Alford Hwy, Holly Springs, NC 27540, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-836b-734f-aa68-f42fd32502c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-836b-734f-aa68-f42fd32502c4",
        "storage_key": "property/6767906449167639/019fec31-836b-734f-aa68-f42fd32502c4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://info.aldi.us/stores/l/nc/holly-springs/7400-gb-alford-hwy/f971",
      "poi_directions_map_url": "https://maps.google.com/?cid=3605198463078738350",
      "poi_item_slug": "aldi",
      "poi_latitude": "35.633536",
      "poi_longitude": "-78.828441",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4486-75ac-91e0-075a23179115.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4486-75ac-91e0-075a23179115",
        "storage_key": "property/6767906449167639/019fec2e-4486-75ac-91e0-075a23179115.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJVKs3lWPrIkRrqmXqOY8CDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_262eef3d-53ea-466f-9ca7-57f58ba16c18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "7016 GB Alford Hwy, Holly Springs, NC 27540, USA",
      "poi_short_description": "Chain retailer supplying a wide range of items from clothes to electronics and groceries, plus a pharmacy.",
      "poi_long_description": "Chain retailer supplying a wide range of items from clothes to electronics and groceries, plus a pharmacy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-810e-74cd-9137-0495ea3624f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-810e-74cd-9137-0495ea3624f7",
        "storage_key": "property/6767906449167639/019fec31-810e-74cd-9137-0495ea3624f7.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/4458-holly-springs-nc/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=14956899154683132633",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.6368236",
      "poi_longitude": "-78.83458030000001",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 919-557-9181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-444f-77aa-a98a-832468755e88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-444f-77aa-a98a-832468755e88",
        "storage_key": "property/6767906449167639/019fec2e-444f-77aa-a98a-832468755e88.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJn5C3Fx-OrIkR2Xo6QImUkc8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_512e2010-00e9-4bd9-8f27-25c3dab2ad5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "100 Grand Hill Pl, Holly Springs, NC 27540, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-8097-771e-b09c-fae2b6709e1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-8097-771e-b09c-fae2b6709e1a",
        "storage_key": "property/6767906449167639/019fec31-8097-771e-b09c-fae2b6709e1a.webp",
        "width": 1280,
        "height": 552
      },
      "poi_business_url": "https://www.target.com/sl/holly-springs/2785",
      "poi_directions_map_url": "https://maps.google.com/?cid=18220007724905106180",
      "poi_item_slug": "target",
      "poi_latitude": "35.6608895",
      "poi_longitude": "-78.8519871",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 919-762-3149",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-444f-77aa-a98a-832468755e88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-444f-77aa-a98a-832468755e88",
        "storage_key": "property/6767906449167639/019fec2e-444f-77aa-a98a-832468755e88.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJcersHR2SrIkRBIvX93142vw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_3e5bfc38-c8f6-41ed-9f7e-a2ad3e83641c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "151 Village Walk Dr, Holly Springs, NC 27540, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-84fc-73ed-8d94-328a6ce1a402.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-84fc-73ed-8d94-328a6ce1a402",
        "storage_key": "property/6767906449167639/019fec31-84fc-73ed-8d94-328a6ce1a402.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cvs.com/store-locator/holly-springs-nc-pharmacies/151-village-walk-dr-holly-springs-nc-27540/storeid=8911?WT.mc_id=LS_GOOGLE_FS_8911",
      "poi_directions_map_url": "https://maps.google.com/?cid=15519308522397186540",
      "poi_item_slug": "cvs",
      "poi_latitude": "35.6417315",
      "poi_longitude": "-78.8389414",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 919-552-5378",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4450-749b-b4f2-f5c4793db3c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4450-749b-b4f2-f5c4793db3c8",
        "storage_key": "property/6767906449167639/019fec2e-4450-749b-b4f2-f5c4793db3c8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpesORAuOrIkR7DktVeCoX9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_94517aae-3e05-47c5-984b-729a86594e3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "301 N Main St, Holly Springs, NC 27540, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-848f-71c8-a72e-c38927019e57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-848f-71c8-a72e-c38927019e57",
        "storage_key": "property/6767906449167639/019fec31-848f-71c8-a72e-c38927019e57.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-301+n+main+st-holly+springs-nc-27540/id=7505",
      "poi_directions_map_url": "https://maps.google.com/?cid=14499236586267048462",
      "poi_item_slug": "walgreens",
      "poi_latitude": "35.655361",
      "poi_longitude": "-78.8351119",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 919-557-3763",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4450-749b-b4f2-f5c4793db3c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4450-749b-b4f2-f5c4793db3c8",
        "storage_key": "property/6767906449167639/019fec2e-4450-749b-b4f2-f5c4793db3c8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwTrUjgCOrIkRDnrL3tqiN8k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_1219cfb1-5ed3-48f0-9052-c22c0c60b9ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Holly Springs Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "648 Holly Springs Rd, Holly Springs, NC 27540, USA",
      "poi_short_description": "Independent pharmacy on Holly Springs Road.",
      "poi_long_description": "Independent pharmacy on Holly Springs Road.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-82e1-74e0-8316-3120f87bafb9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-82e1-74e0-8316-3120f87bafb9",
        "storage_key": "property/6767906449167639/019fec31-82e1-74e0-8316-3120f87bafb9.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "http://www.hollyspringspharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15000881104387964695",
      "poi_item_slug": "holly-springs-pharmacy",
      "poi_latitude": "35.654431",
      "poi_longitude": "-78.8251197",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 919-346-6689",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-b465-755c-b022-605a05507536.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec31-b465-755c-b022-605a05507536",
        "storage_key": "property/6767906449167639/019fec31-b465-755c-b022-605a05507536.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ86ZFGAiOrIkRF__p6OLVLdA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_639c72b3-dad2-4a1a-b543-4b916c3fff28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Holly Grove Elementary School",
      "poi_type": "Education",
      "poi_address": "1451 Avent Ferry Rd, Holly Springs, NC 27540, USA",
      "poi_short_description": "Public elementary school, Wake County Public School System, on Avent Ferry Road.",
      "poi_long_description": "Public elementary school, Wake County Public School System, on Avent Ferry Road.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.wcpss.net/hollygrovees",
      "poi_directions_map_url": "https://maps.google.com/?cid=9618671654099557021",
      "poi_item_slug": "holly-grove-elementary-school",
      "poi_latitude": "35.6316368",
      "poi_longitude": "-78.8503312",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 919-577-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4450-749b-b4f2-f35464ac5461.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4450-749b-b4f2-f35464ac5461",
        "storage_key": "property/6767906449167639/019fec2e-4450-749b-b4f2-f35464ac5461.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJST4GRsORrIkRnRq5UehifIU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_29ec4d0e-22ae-4c57-9357-277278e2c99d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Holly Grove Middle School",
      "poi_type": "Education",
      "poi_address": "1401 Avent Ferry Rd, Holly Springs, NC 27540, USA",
      "poi_short_description": "Public middle school, Wake County Public School System, on Avent Ferry Road.",
      "poi_long_description": "Public middle school, Wake County Public School System, on Avent Ferry Road.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-86cf-709d-8ff1-7dbab333d80e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-86cf-709d-8ff1-7dbab333d80e",
        "storage_key": "property/6767906449167639/019fec31-86cf-709d-8ff1-7dbab333d80e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wcpss.net/hollygrovems",
      "poi_directions_map_url": "https://maps.google.com/?cid=11479203408816626071",
      "poi_item_slug": "holly-grove-middle-school",
      "poi_latitude": "35.6314545",
      "poi_longitude": "-78.8485266",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 919-567-4177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4450-749b-b4f2-f35464ac5461.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4450-749b-b4f2-f35464ac5461",
        "storage_key": "property/6767906449167639/019fec2e-4450-749b-b4f2-f35464ac5461.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ49JcKduRrIkRl9n3Tq5STp8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_7e19d7e4-fff4-4b78-a047-06c11501bfa4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Holly Springs High School",
      "poi_type": "Education",
      "poi_address": "5329 Cass Holt Rd, Holly Springs, NC 27540, USA",
      "poi_short_description": "Public high school, Wake County Public School System, on Cass Holt Road.",
      "poi_long_description": "Public high school, Wake County Public School System, on Cass Holt Road.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-8865-725b-b52d-91c813eba0c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-8865-725b-b52d-91c813eba0c0",
        "storage_key": "property/6767906449167639/019fec31-8865-725b-b52d-91c813eba0c0.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.wcpss.net/hollyspringshs",
      "poi_directions_map_url": "https://maps.google.com/?cid=1428945683267357728",
      "poi_item_slug": "holly-springs-high-school",
      "poi_latitude": "35.62794969999999",
      "poi_longitude": "-78.84969869999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 919-577-1444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4450-749b-b4f2-f35464ac5461.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4450-749b-b4f2-f35464ac5461",
        "storage_key": "property/6767906449167639/019fec2e-4450-749b-b4f2-f35464ac5461.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJT2PPOduRrIkRIIx6Loei1BM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_ef2252f0-7977-45b5-965a-4371c6977916",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Primrose School at Holly Grove",
      "poi_type": "Education",
      "poi_address": "1530 Avent Ferry Rd, Holly Springs, NC 27540, USA",
      "poi_short_description": "Private preschool and early-education center on Avent Ferry Road.",
      "poi_long_description": "Private preschool and early-education center on Avent Ferry Road.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-879d-727d-99c9-e60cb9c5cbe6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-879d-727d-99c9-e60cb9c5cbe6",
        "storage_key": "property/6767906449167639/019fec31-879d-727d-99c9-e60cb9c5cbe6.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.primroseschools.com/schools/holly-grove/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17699648590356048226",
      "poi_item_slug": "primrose-school-at-holly-grove",
      "poi_latitude": "35.632485",
      "poi_longitude": "-78.854323",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 919-567-1114",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4450-749b-b4f2-f35464ac5461.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4450-749b-b4f2-f35464ac5461",
        "storage_key": "property/6767906449167639/019fec2e-4450-749b-b4f2-f35464ac5461.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs6oeKd2RrIkRYmlqvZ3IofU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_cf87594f-9083-4a9b-abd5-93f13991d595",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Buckhorn Creek Elementary School",
      "poi_type": "Education",
      "poi_address": "5651 Honeycutt Rd, Holly Springs, NC 27540, USA",
      "poi_short_description": "Public elementary school, Wake County Public School System, on Honeycutt Road.",
      "poi_long_description": "Public elementary school, Wake County Public School System, on Honeycutt Road.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.wcpss.net/buckhorncreekes",
      "poi_directions_map_url": "https://maps.google.com/?cid=11315236772874533971",
      "poi_item_slug": "buckhorn-creek-elementary-school",
      "poi_latitude": "35.618555",
      "poi_longitude": "-78.84456019999999",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 919-694-8970",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4450-749b-b4f2-f35464ac5461.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4450-749b-b4f2-f35464ac5461",
        "storage_key": "property/6767906449167639/019fec2e-4450-749b-b4f2-f35464ac5461.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs3lgVtGRrIkRU7yf7OTLB50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_c2e23b67-e47c-435e-9338-1c69718f494d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Pine Springs Preparatory Academy",
      "poi_type": "Education",
      "poi_address": "220 Rosewood Centre Dr, Holly Springs, NC 27540, USA",
      "poi_short_description": "Public charter school on Rosewood Centre Drive in Holly Springs.",
      "poi_long_description": "Public charter school on Rosewood Centre Drive in Holly Springs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-8b44-75ad-99a0-432710fc7942.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-8b44-75ad-99a0-432710fc7942",
        "storage_key": "property/6767906449167639/019fec31-8b44-75ad-99a0-432710fc7942.webp",
        "width": 572,
        "height": 461
      },
      "poi_business_url": "https://pinespringsprep.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7840109983191673723",
      "poi_item_slug": "pine-springs-preparatory-academy",
      "poi_latitude": "35.67686140000001",
      "poi_longitude": "-78.8341007",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 919-439-9448",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4450-749b-b4f2-f35464ac5461.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4450-749b-b4f2-f35464ac5461",
        "storage_key": "property/6767906449167639/019fec2e-4450-749b-b4f2-f35464ac5461.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPW7ItYqNrIkReysitH2qzWw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_01d2f3ed-1b39-4bef-88fa-0e1f44076216",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Thales Academy Holly Springs Pre-K–12",
      "poi_type": "Education",
      "poi_address": "11244 Holly Springs New Hill Rd, Holly Springs, NC 27540, USA",
      "poi_short_description": "Private Pre-K–12 school on Holly Springs New Hill Road.",
      "poi_long_description": "Private Pre-K–12 school on Holly Springs New Hill Road.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-8aea-719c-9f2b-05c174f5cb8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-8aea-719c-9f2b-05c174f5cb8a",
        "storage_key": "property/6767906449167639/019fec31-8aea-719c-9f2b-05c174f5cb8a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.thalesacademy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8764199351956264520",
      "poi_item_slug": "thales-academy-holly-springs-pre-k12",
      "poi_latitude": "35.6616325",
      "poi_longitude": "-78.8567504",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 919-762-7297",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4450-749b-b4f2-f35464ac5461.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4450-749b-b4f2-f35464ac5461",
        "storage_key": "property/6767906449167639/019fec2e-4450-749b-b4f2-f35464ac5461.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJt46fy_yTrIkRSNYPOuCwoHk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_086d0853-3869-4ab2-a8ce-d3eadc0548fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Bombshell Beer Company",
      "poi_type": "Restaurants",
      "poi_address": "120 Quantum Dr, Holly Springs, NC 27540, USA",
      "poi_short_description": "Holly Springs craft brewery with a taproom on Quantum Drive.",
      "poi_long_description": "Holly Springs craft brewery with a taproom on Quantum Drive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-8cb0-75dd-97fb-23a1d67677ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-8cb0-75dd-97fb-23a1d67677ff",
        "storage_key": "property/6767906449167639/019fec31-8cb0-75dd-97fb-23a1d67677ff.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.bombshellbeer.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18022107138822258670",
      "poi_item_slug": "bombshell-beer-company",
      "poi_latitude": "35.6582295",
      "poi_longitude": "-78.8368653",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 919-823-1933",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4450-749b-b4f2-f5c4793db3c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4450-749b-b4f2-f5c4793db3c8",
        "storage_key": "property/6767906449167639/019fec2e-4450-749b-b4f2-f5c4793db3c8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr-bWl_-NrIkR7j-IIfViG_o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "custom_9e563756-5496-4f50-9139-ec094563fa6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Holly Springs Cultural Center",
      "poi_type": "Entertainment",
      "poi_address": "300 W Ballentine St, Holly Springs, NC 27540, USA",
      "poi_short_description": "Cultural center offering drama and comedy theater performances, as well as free admission.",
      "poi_long_description": "Cultural center offering drama and comedy theater performances, as well as free admission.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-8eb7-71d9-a1b1-6735c39aba8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-8eb7-71d9-a1b1-6735c39aba8c",
        "storage_key": "property/6767906449167639/019fec31-8eb7-71d9-a1b1-6735c39aba8c.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "https://www.hollyspringsnc.gov/323/Cultural-Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=259713566004267788",
      "poi_item_slug": "holly-springs-cultural-center",
      "poi_latitude": "35.6501999",
      "poi_longitude": "-78.8362743",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 919-567-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4450-749b-b4f2-f5c4793db3c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4450-749b-b4f2-f5c4793db3c8",
        "storage_key": "property/6767906449167639/019fec2e-4450-749b-b4f2-f5c4793db3c8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdROrJQKOrIkRDMsIvRywmgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cultural_center"
    },
    {
      "id": "custom_dd0572c4-7ea1-4475-b407-c2ed5b7efcc2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Sugg Farm at Bass Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Grigsby Ave, Holly Springs, NC 27540, USA",
      "poi_short_description": "Town of Holly Springs park on the historic Sugg Farm property next to Bass Lake, with open fields and trails.",
      "poi_long_description": "Town of Holly Springs park on the historic Sugg Farm property next to Bass Lake, with open fields and trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-8cbe-7498-a114-03075824ce7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-8cbe-7498-a114-03075824ce7e",
        "storage_key": "property/6767906449167639/019fec31-8cbe-7498-a114-03075824ce7e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://m.facebook.com/431047373669682/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2607625462611485896",
      "poi_item_slug": "sugg-farm-at-bass-lake-park",
      "poi_latitude": "35.639267",
      "poi_longitude": "-78.81600399999999",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 919-557-2496",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4475-77bf-a4f7-7eae5e90c354.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4475-77bf-a4f7-7eae5e90c354",
        "storage_key": "property/6767906449167639/019fec2e-4475-77bf-a4f7-7eae5e90c354.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJk59cSROOrIkRyKQ43oolMCQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_74eba4a2-8926-4c7c-a69e-127b6ec04e35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Bass Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "900 Bass Lake Rd, Holly Springs, NC 27540, USA",
      "poi_short_description": "Recreational area with trails, conference facilities, a nature center & picnic pavilions.",
      "poi_long_description": "Recreational area with trails, conference facilities, a nature center & picnic pavilions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-36c4-72ae-8bf5-abfcf6c15f55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2e-36c4-72ae-8bf5-abfcf6c15f55",
        "storage_key": "property/6767906449167639/019fec2e-36c4-72ae-8bf5-abfcf6c15f55.webp",
        "width": 1280,
        "height": 600
      },
      "poi_business_url": "https://www.hollyspringsnc.gov/320",
      "poi_directions_map_url": "https://maps.google.com/?cid=4922128404816789946",
      "poi_item_slug": "bass-lake-park",
      "poi_latitude": "35.64257130000001",
      "poi_longitude": "-78.8052199",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 919-567-4028",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4475-77bf-a4f7-7eae5e90c354.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4475-77bf-a4f7-7eae5e90c354",
        "storage_key": "property/6767906449167639/019fec2e-4475-77bf-a4f7-7eae5e90c354.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJvVbpKWWOrIkRugH3o7TpTkQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_881515e8-47dd-4d1c-a852-615756e32f7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "AMC DINE-IN Holly Springs 9",
      "poi_type": "Entertainment",
      "poi_address": "320 Grand Hill Pl, Holly Springs, NC 27540, USA",
      "poi_short_description": "Clean, spacious, comfortable theater showing the latest releases and serving snacks and pub grub.",
      "poi_long_description": "Clean, spacious, comfortable theater showing the latest releases and serving snacks and pub grub.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-90aa-760a-a51d-118f9951eea1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-90aa-760a-a51d-118f9951eea1",
        "storage_key": "property/6767906449167639/019fec31-90aa-760a-a51d-118f9951eea1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/raleigh-durham/amc-dine-in-holly-springs-9",
      "poi_directions_map_url": "https://maps.google.com/?cid=8116549878717757005",
      "poi_item_slug": "amc-dine-in-holly-springs-9",
      "poi_latitude": "35.66698400000001",
      "poi_longitude": "-78.8435262",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 919-285-0580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-b483-7594-8ac0-38b78ef42d5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec31-b483-7594-8ac0-38b78ef42d5a",
        "storage_key": "property/6767906449167639/019fec31-b483-7594-8ac0-38b78ef42d5a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJe3DPnASSrIkRTTa2ghzHo3A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_d18801fa-54f7-4e21-a51e-cb8178476d1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Koka Booth Amphitheatre",
      "poi_type": "Entertainment",
      "poi_address": "8003 Regency Pkwy, Cary, NC 27518, USA",
      "poi_short_description": "Home to Koka Booth Amphitheatre, this verdant park hosts musical performances & movie screenings.",
      "poi_long_description": "Home to Koka Booth Amphitheatre, this verdant park hosts musical performances & movie screenings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-9246-7306-a930-0ed01cc80be3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-9246-7306-a930-0ed01cc80be3",
        "storage_key": "property/6767906449167639/019fec31-9246-7306-a930-0ed01cc80be3.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://boothamphitheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10691284619627796565",
      "poi_item_slug": "koka-booth-amphitheatre",
      "poi_latitude": "35.7290391",
      "poi_longitude": "-78.7958541",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 14 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 919-462-2025",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4450-749b-b4f2-f5c4793db3c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4450-749b-b4f2-f5c4793db3c8",
        "storage_key": "property/6767906449167639/019fec2e-4450-749b-b4f2-f5c4793db3c8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI1-HrtWMrIkRVRiDebcSX5Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    },
    {
      "id": "custom_48f8a4e1-e6bd-426b-ae3d-520d925efe61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Fuquay-Varina Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "123 E Vance St, Fuquay-Varina, NC 27526, USA",
      "poi_short_description": "Theater and gallery featuring plays, concerts, dance and art shows.",
      "poi_long_description": "Theater and gallery featuring plays, concerts, dance and art shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-916f-75cb-a19f-fdda5ca29468.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-916f-75cb-a19f-fdda5ca29468",
        "storage_key": "property/6767906449167639/019fec31-916f-75cb-a19f-fdda5ca29468.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fuquay-varina.org/1111/Arts-Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=14425124915317742871",
      "poi_item_slug": "fuquay-varina-arts-center",
      "poi_latitude": "35.582172",
      "poi_longitude": "-78.798451",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 919-567-3920",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4450-749b-b4f2-f5c4793db3c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4450-749b-b4f2-f5c4793db3c8",
        "storage_key": "property/6767906449167639/019fec2e-4450-749b-b4f2-f5c4793db3c8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3WAoB5yPrIkRF50m0q5WMMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_13b28043-9f7f-4d84-8218-e2ca8bdeb2b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Rex Holly Springs Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "850 S Main St, Holly Springs, NC 27540, USA",
      "poi_short_description": "UNC Health Rex community hospital with a 24-hour emergency department on South Main Street.",
      "poi_long_description": "UNC Health Rex community hospital with a 24-hour emergency department on South Main Street.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-32f3-7791-900a-22c1af3b6c43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2e-32f3-7791-900a-22c1af3b6c43",
        "storage_key": "property/6767906449167639/019fec2e-32f3-7791-900a-22c1af3b6c43.webp",
        "width": 837,
        "height": 470
      },
      "poi_business_url": "https://www.unchealth.org/care-services/locations/rex-holly-springs-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=9849217788993358050",
      "poi_item_slug": "rex-holly-springs-hospital",
      "poi_latitude": "35.6427099",
      "poi_longitude": "-78.8363158",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 984-960-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-444f-77aa-a98a-7d0b87caa511.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-444f-77aa-a98a-7d0b87caa511",
        "storage_key": "property/6767906449167639/019fec2e-444f-77aa-a98a-7d0b87caa511.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJQRYKKWWPrIkR4khoTGVzr4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_870cd212-4649-4e1b-88bb-c270f811f0c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "UNC Urgent Care at Holly Springs",
      "poi_type": "Health and Wellness",
      "poi_address": "781 Avent Ferry Rd Ste 102, Holly Springs, NC 27540, USA",
      "poi_short_description": "Walk-in urgent care clinic on Avent Ferry Road, part of UNC Health Rex.",
      "poi_long_description": "Walk-in urgent care clinic on Avent Ferry Road, part of UNC Health Rex.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-9371-702c-8d35-2c6eeede2563.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-9371-702c-8d35-2c6eeede2563",
        "storage_key": "property/6767906449167639/019fec31-9371-702c-8d35-2c6eeede2563.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.unchealth.org/care-services/locations/unc-urgent-care-at-holly-springs-unc-health-rex-at-holly-springs",
      "poi_directions_map_url": "https://maps.google.com/?cid=13585811656991744676",
      "poi_item_slug": "unc-urgent-care-at-holly-springs",
      "poi_latitude": "35.6431516",
      "poi_longitude": "-78.8374005",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 919-567-6120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4450-749b-b4f2-f5c4793db3c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4450-749b-b4f2-f5c4793db3c8",
        "storage_key": "property/6767906449167639/019fec2e-4450-749b-b4f2-f5c4793db3c8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm4nhdh2OrIkRpKJaqLh_irw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_e7e6364a-0cdc-4c5a-bc83-f957b807c534",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Duke Urgent Care Holly Springs",
      "poi_type": "Health and Wellness",
      "poi_address": "401 Irving Pkwy #130, Holly Springs, NC 27540, USA",
      "poi_short_description": "Walk-in urgent care clinic on Irving Parkway, part of Duke Health.",
      "poi_long_description": "Walk-in urgent care clinic on Irving Parkway, part of Duke Health.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-9612-70ae-9515-c8134cba1353.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-9612-70ae-9515-c8134cba1353",
        "storage_key": "property/6767906449167639/019fec31-9612-70ae-9515-c8134cba1353.webp",
        "width": 1280,
        "height": 679
      },
      "poi_business_url": "https://www.dukehealth.org/locations/duke-urgent-care-holly-springs",
      "poi_directions_map_url": "https://maps.google.com/?cid=6159734179737373719",
      "poi_item_slug": "duke-urgent-care-holly-springs",
      "poi_latitude": "35.6571353",
      "poi_longitude": "-78.8494113",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 919-385-5060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4450-749b-b4f2-f5c4793db3c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4450-749b-b4f2-f5c4793db3c8",
        "storage_key": "property/6767906449167639/019fec2e-4450-749b-b4f2-f5c4793db3c8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1QXj76yRrIkRFwwUzpnFe1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_30b13cab-70a1-48ff-b1ba-e03247d54b08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "141 Grand Hill Pl, Holly Springs, NC 27540, USA",
      "poi_short_description": "Fitness center featuring heart rate-based interval training and custom workouts for individuals, plus friendly staff, coaches and trainers.",
      "poi_long_description": "Fitness center featuring heart rate-based interval training and custom workouts for individuals, plus friendly staff, coaches and trainers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-9993-713c-85e3-bccf62381ac2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-9993-713c-85e3-bccf62381ac2",
        "storage_key": "property/6767906449167639/019fec31-9993-713c-85e3-bccf62381ac2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/holly-springs-north-carolina-0358",
      "poi_directions_map_url": "https://maps.google.com/?cid=9266287144134790099",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "35.6613201",
      "poi_longitude": "-78.8488843",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 919-267-1683",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4450-749b-b4f2-f5c4793db3c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4450-749b-b4f2-f5c4793db3c8",
        "storage_key": "property/6767906449167639/019fec2e-4450-749b-b4f2-f5c4793db3c8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU1ohNgOSrIkR00vsDBB3mIA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d468851d-9cdf-4472-92cd-a0ad6d695c14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Parrish Womble Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1201 Grigsby Ave, Holly Springs, NC 27540, USA",
      "poi_short_description": "Popular recreation area offering walking paths as well as baseball and soccer fields, tennis courts, playgrounds and more.",
      "poi_long_description": "Popular recreation area offering walking paths as well as baseball and soccer fields, tennis courts, playgrounds and more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-9632-7091-8a90-b78129a1584a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-9632-7091-8a90-b78129a1584a",
        "storage_key": "property/6767906449167639/019fec31-9632-7091-8a90-b78129a1584a.webp",
        "width": 1280,
        "height": 984
      },
      "poi_business_url": "https://www.hollyspringsnc.gov/332",
      "poi_directions_map_url": "https://maps.google.com/?cid=13088646927464418812",
      "poi_item_slug": "parrish-womble-park",
      "poi_latitude": "35.642208",
      "poi_longitude": "-78.827379",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 919-557-9600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4475-77bf-a4f7-7eae5e90c354.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4475-77bf-a4f7-7eae5e90c354",
        "storage_key": "property/6767906449167639/019fec2e-4475-77bf-a4f7-7eae5e90c354.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCU9YoBqOrIkR_E0Grgg3pLU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_eb5e4dd2-9a3a-4c7d-8f69-6f12885ff07a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Jones Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "405 School Days Ln, Holly Springs, NC 27540, USA",
      "poi_short_description": "Park with a disc golf course, playground, hiking, picnic areas, and baseball fields.",
      "poi_long_description": "Park with a disc golf course, playground, hiking, picnic areas, and baseball fields.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-9a6d-75c0-99bc-e22ee6631610.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-9a6d-75c0-99bc-e22ee6631610",
        "storage_key": "property/6767906449167639/019fec31-9a6d-75c0-99bc-e22ee6631610.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hollyspringsnc.gov/328/Jones-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13771168868033196374",
      "poi_item_slug": "jones-park",
      "poi_latitude": "35.657684",
      "poi_longitude": "-78.829171",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 919-557-9600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4475-77bf-a4f7-7eae5e90c354.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4475-77bf-a4f7-7eae5e90c354",
        "storage_key": "property/6767906449167639/019fec2e-4475-77bf-a4f7-7eae5e90c354.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJxQRu6PyNrIkRVnEJaR8FHb8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_869d7e12-f788-46b3-99ae-9fbfc99d22d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "North Main Athletic Complex",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "101 Sportsmanship Wy, Holly Springs, NC 27540, USA",
      "poi_short_description": "Sports park with soccer fields, as well as tennis and basketball courts, a playground, and restrooms.",
      "poi_long_description": "Sports park with soccer fields, as well as tennis and basketball courts, a playground, and restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-3870-728e-98e6-cc5bad85b184.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2e-3870-728e-98e6-cc5bad85b184",
        "storage_key": "property/6767906449167639/019fec2e-3870-728e-98e6-cc5bad85b184.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hollyspringsnc.gov/607",
      "poi_directions_map_url": "https://maps.google.com/?cid=946937904768213562",
      "poi_item_slug": "north-main-athletic-complex",
      "poi_latitude": "35.6674168",
      "poi_longitude": "-78.8371252",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 919-746-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4475-77bf-a4f7-7eae5e90c354.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4475-77bf-a4f7-7eae5e90c354",
        "storage_key": "property/6767906449167639/019fec2e-4475-77bf-a4f7-7eae5e90c354.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJlyXlAgiSrIkROuIP3gEzJA0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_800605fc-90d2-45d4-9334-c7bed1885341",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "W.E. Hunt Recreation Center",
      "poi_type": "Health and Wellness",
      "poi_address": "301 Stinson Ave, Holly Springs, NC 27540, USA",
      "poi_short_description": "Community recreation center with an indoor track, fitness center, and basketball court, plus classes.",
      "poi_long_description": "Community recreation center with an indoor track, fitness center, and basketball court, plus classes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-9acb-71cd-9db6-7297af73150e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-9acb-71cd-9db6-7297af73150e",
        "storage_key": "property/6767906449167639/019fec31-9acb-71cd-9db6-7297af73150e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hollyspringsnc.us/340/Hunt-Recreation-Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=17482344511084545351",
      "poi_item_slug": "we-hunt-recreation-center",
      "poi_latitude": "35.6465087",
      "poi_longitude": "-78.8292532",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 919-557-9600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4450-749b-b4f2-f5c4793db3c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4450-749b-b4f2-f5c4793db3c8",
        "storage_key": "property/6767906449167639/019fec2e-4450-749b-b4f2-f5c4793db3c8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr20bGwWOrIkRR8UxGLXDnfI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_23cb36e5-5340-4080-a224-d1df69426da0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Raleigh-Durham International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2400 John Brantley Blvd, Morrisville, NC 27560, USA",
      "poi_short_description": "Hub with domestic, London & Caribbean flights, plus a public observation area for plane-watching.",
      "poi_long_description": "Hub with domestic, London & Caribbean flights, plus a public observation area for plane-watching.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-9c01-7308-88a0-d25fb4c2e91b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-9c01-7308-88a0-d25fb4c2e91b",
        "storage_key": "property/6767906449167639/019fec31-9c01-7308-88a0-d25fb4c2e91b.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.rdu.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16394108500305999341",
      "poi_item_slug": "raleigh-durham-international-airport",
      "poi_latitude": "35.8797678",
      "poi_longitude": "-78.7855512",
      "poi_miles_from_property": "25.2 mi",
      "poi_walking_minutes": "9 hours 15 mins",
      "poi_biking_minutes": "1 hour 57 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 919-840-2123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-b46b-76cd-81e4-40aa02e39051.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec31-b46b-76cd-81e4-40aa02e39051",
        "storage_key": "property/6767906449167639/019fec31-b46b-76cd-81e4-40aa02e39051.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJz3mOAvrwrIkR7XXzQdKSg-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_83d843f6-2c41-42f3-a526-5c912ec2af92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Raleigh Union Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "510 W Martin St, Raleigh, NC 27601, USA",
      "poi_short_description": "Amtrak station in downtown Raleigh on West Martin Street.",
      "poi_long_description": "Amtrak station in downtown Raleigh on West Martin Street.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-9f8c-7602-8750-10e71a317c83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-9f8c-7602-8750-10e71a317c83",
        "storage_key": "property/6767906449167639/019fec31-9f8c-7602-8750-10e71a317c83.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/stations/rgh",
      "poi_directions_map_url": "https://maps.google.com/?cid=7140744060459657958",
      "poi_item_slug": "raleigh-union-station",
      "poi_latitude": "35.7772979",
      "poi_longitude": "-78.6475134",
      "poi_miles_from_property": "17.6 mi",
      "poi_walking_minutes": "6 hours 29 mins",
      "poi_biking_minutes": "1 hour 46 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-b469-75eb-bd87-4aba02616693.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec31-b469-75eb-bd87-4aba02616693",
        "storage_key": "property/6767906449167639/019fec31-b469-75eb-bd87-4aba02616693.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5_VemHBfrIkR5qqtw-MEGWM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_1986fa5d-901e-402a-b70e-2cef461f5826",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "FUJIFILM Biotechnologies",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 Biotechnology Ave, Holly Springs, NC 27540, USA",
      "poi_short_description": "Biopharmaceutical manufacturing campus on Biotechnology Avenue in Holly Springs.",
      "poi_long_description": "Biopharmaceutical manufacturing campus on Biotechnology Avenue in Holly Springs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-a4a3-7119-a71f-5c07ae956df2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-a4a3-7119-a71f-5c07ae956df2",
        "storage_key": "property/6767906449167639/019fec31-a4a3-7119-a71f-5c07ae956df2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.fujifilmdiosynth.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15566780351475797469",
      "poi_item_slug": "fujifilm-biotechnologies",
      "poi_latitude": "35.6544696",
      "poi_longitude": "-78.8754553",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4450-749b-b4f2-f5c4793db3c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4450-749b-b4f2-f5c4793db3c8",
        "storage_key": "property/6767906449167639/019fec2e-4450-749b-b4f2-f5c4793db3c8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ72TjZVWRrIkR3c0-2kBQCNg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_6a96b6e4-a0e7-4d3e-88fd-959c03adcbbf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Seqirus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "475 Green Oaks Pkwy, Holly Springs, NC 27540, USA",
      "poi_short_description": "Influenza vaccine manufacturing site on Green Oaks Parkway, one of Holly Springs' largest employers.",
      "poi_long_description": "Influenza vaccine manufacturing site on Green Oaks Parkway, one of Holly Springs' largest employers.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.seqirus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13468862125036284169",
      "poi_item_slug": "seqirus",
      "poi_latitude": "35.6550433",
      "poi_longitude": "-78.86519179999999",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 919-577-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4450-749b-b4f2-f5c4793db3c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4450-749b-b4f2-f5c4793db3c8",
        "storage_key": "property/6767906449167639/019fec2e-4450-749b-b4f2-f5c4793db3c8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP16qZI6RrIkRCSmA270C67o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_c2e56415-b285-434a-a26f-6aab918fe809",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Research Triangle Park Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "700 Park Offices Dr Ste 007, Durham, NC 27713, USA",
      "poi_short_description": "Headquarters office of the Research Triangle Park, the research and technology campus between Raleigh, Durham and Chapel Hill.",
      "poi_long_description": "Headquarters office of the Research Triangle Park, the research and technology campus between Raleigh, Durham and Chapel Hill.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-a102-7799-af29-3fdfcf08f6b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-a102-7799-af29-3fdfcf08f6b0",
        "storage_key": "property/6767906449167639/019fec31-a102-7799-af29-3fdfcf08f6b0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rtp.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4702177776564566780",
      "poi_item_slug": "research-triangle-park-headquarters",
      "poi_latitude": "35.8975759",
      "poi_longitude": "-78.8713709",
      "poi_miles_from_property": "20.1 mi",
      "poi_walking_minutes": "7 hours 24 mins",
      "poi_biking_minutes": "1 hour 57 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 919-549-8181",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4450-749b-b4f2-f5c4793db3c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4450-749b-b4f2-f5c4793db3c8",
        "storage_key": "property/6767906449167639/019fec2e-4450-749b-b4f2-f5c4793db3c8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ97Q2lurvrIkR_PrdSsZ9QUE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_1a2c7997-4341-4b59-a6dc-bb099c2d5279",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "SAS Institute Inc",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 SAS Campus Dr, Cary, NC 27513, USA",
      "poi_short_description": "World headquarters of the SAS analytics software company in Cary.",
      "poi_long_description": "World headquarters of the SAS analytics software company in Cary.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec31-a4fd-715e-b98a-016a1479473c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec31-a4fd-715e-b98a-016a1479473c",
        "storage_key": "property/6767906449167639/019fec31-a4fd-715e-b98a-016a1479473c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8053403503889832528",
      "poi_item_slug": "sas-institute-inc",
      "poi_latitude": "35.8184931",
      "poi_longitude": "-78.7539266",
      "poi_miles_from_property": "16.8 mi",
      "poi_walking_minutes": "6 hours 12 mins",
      "poi_biking_minutes": "1 hour 34 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 919-677-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4450-749b-b4f2-f5c4793db3c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4450-749b-b4f2-f5c4793db3c8",
        "storage_key": "property/6767906449167639/019fec2e-4450-749b-b4f2-f5c4793db3c8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuQkDbVzxrIkRUFo9atFvw28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ebde1fee-b05e-45bb-b729-3fe7de83033d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "2240 Ralph Stephens Rd, Holly Springs, NC 27540, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-1df8-746a-adf1-7a564d1c1c2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2e-1df8-746a-adf1-7a564d1c1c2d",
        "storage_key": "property/6767906449167639/019fec2e-1df8-746a-adf1-7a564d1c1c2d.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7951273884141476643",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "35.630735",
      "poi_longitude": "-78.828206",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 919-586-3155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-444f-77aa-a98a-832468755e88.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-444f-77aa-a98a-832468755e88",
        "storage_key": "property/6767906449167639/019fec2e-444f-77aa-a98a-832468755e88.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjwtdmFGPrIkRI9sXUHiZWG4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_2c28f332-6325-43e2-bc0d-b5d73af9eca5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Harris Teeter",
      "poi_type": "Shopping & Retail",
      "poi_address": "324 Village Walk Dr, Holly Springs, NC 27540, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty aids.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty aids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-2297-72b8-bacd-53cf0e95601b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2e-2297-72b8-bacd-53cf0e95601b",
        "storage_key": "property/6767906449167639/019fec2e-2297-72b8-bacd-53cf0e95601b.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.harristeeter.com/stores/grocery/nc/holly-springs/southpark-village/097/00311?cid=loc_09700311_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=10264312862097354188",
      "poi_item_slug": "harris-teeter",
      "poi_latitude": "35.6395754",
      "poi_longitude": "-78.8391176",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 919-552-1596",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4486-75ac-91e0-075a23179115.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4486-75ac-91e0-075a23179115",
        "storage_key": "property/6767906449167639/019fec2e-4486-75ac-91e0-075a23179115.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoVAXAx6OrIkRzC3JWCoqco4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_54a94285-4bbe-4228-a9c6-561b648dd04d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Wake Technical Community College - Western Wake Campus",
      "poi_type": "Education",
      "poi_address": "3434 Kildaire Farm Rd, Cary, NC 27518, USA",
      "poi_short_description": "Wake Tech's Western Wake campus on Kildaire Farm Road in Cary.",
      "poi_long_description": "Wake Tech's Western Wake campus on Kildaire Farm Road in Cary.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-20e4-70cb-ae52-94dab56376b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2e-20e4-70cb-ae52-94dab56376b0",
        "storage_key": "property/6767906449167639/019fec2e-20e4-70cb-ae52-94dab56376b0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.waketech.edu/about-wake-tech/campuses-centers/western-wake-campus",
      "poi_directions_map_url": "https://maps.google.com/?cid=12261998031004535779",
      "poi_item_slug": "wake-technical-community-college---western-wake-campus",
      "poi_latitude": "35.7059084",
      "poi_longitude": "-78.7955089",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 919-335-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4450-749b-b4f2-f35464ac5461.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4450-749b-b4f2-f35464ac5461",
        "storage_key": "property/6767906449167639/019fec2e-4450-749b-b4f2-f35464ac5461.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY41Q1gKNrIkR44uQCj5eK6o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_637f4326-34e4-4020-8570-9a1fb5bae7cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Ting Stadium",
      "poi_type": "Entertainment",
      "poi_address": "101 Tennis Ct, Holly Springs, NC 27540, USA",
      "poi_short_description": "Multi-sport stadium at the North Main Athletic Complex on Tennis Court in Holly Springs.",
      "poi_long_description": "Multi-sport stadium at the North Main Athletic Complex on Tennis Court in Holly Springs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-27b3-716c-a2c2-ca961bf3782b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2e-27b3-716c-a2c2-ca961bf3782b",
        "storage_key": "property/6767906449167639/019fec2e-27b3-716c-a2c2-ca961bf3782b.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6728199792623538515",
      "poi_item_slug": "ting-stadium",
      "poi_latitude": "35.667748",
      "poi_longitude": "-78.83650589999999",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4489-767d-a1f2-6ed5db6080e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4489-767d-a1f2-6ed5db6080e8",
        "storage_key": "property/6767906449167639/019fec2e-4489-767d-a1f2-6ed5db6080e8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5VHckfeNrIkRU9EuWRBeX10",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_e239419b-decc-4779-8149-ed2baacfbb08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "custom",
      "poi_name": "Harris Lake County Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2112 County Park Dr, New Hill, NC 27562, USA",
      "poi_short_description": "Known for an 18-basket disc golf course, this vast day park hosts cycling, catfish angling & hiking.",
      "poi_long_description": "Known for an 18-basket disc golf course, this vast day park hosts cycling, catfish angling & hiking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-39e6-714f-b2fc-26d32db1e3bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2e-39e6-714f-b2fc-26d32db1e3bc",
        "storage_key": "property/6767906449167639/019fec2e-39e6-714f-b2fc-26d32db1e3bc.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.wakegov.com/departments-government/parks-recreation-and-open-space/all-parks-trails/harris-lake-county-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=5693579633023564119",
      "poi_item_slug": "harris-lake-county-park",
      "poi_latitude": "35.6212268",
      "poi_longitude": "-78.92784549999999",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 919-387-4342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167639/019fec2e-4475-77bf-a4f7-7eae5e90c354.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2e-4475-77bf-a4f7-7eae5e90c354",
        "storage_key": "property/6767906449167639/019fec2e-4475-77bf-a4f7-7eae5e90c354.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz4ns49SWrIkRV7nEpoKoA08",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    }
  ],
  "office_hours": [
    {
      "id": "ec_bc45889c7dc8de613701c1fd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_f95200d8d1707c78d9f1adcd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_d6d5ba79391c1cc420d9b692",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_ea043a93a1c05a2e15da2945",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_6b24bccc05992101439e4c9e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_86bc8f87f81cf25e80fbad86",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "rating": "5",
      "name": "Brendan j",
      "text": "Having lived in CA, IL, CO and FL. now NC at Stephens Farms. Hands down this has been one of the best living experiences we have encoutered with the service from the staff and the property and home. The rooms are amazign size and the kitchen outstanding. Overall living and quality of life has been wonderful. Minor move in details to be addressed and Stephens Farms was right thre, no repairs needed the townhouse. Overall experience has been wonderful. Chelsea a stephens farms advisor helped us to relocate she was amazing got us into our home quickly. She has been there as a huge support I cannot thank Chelsea enough for the job she has done for our family. Lief the property manager has been just as helpful in more than one way of our move in and move out experience. We are very greateful to have been tenants at Stephen Farms. I hihgly suggest living here you will not regret it. It is a great quiet community especially for family and proffesional mindset Individuals that want quality of life. Not to mention the ammenities walking paths, pool clubhouse and nearby restaurants, shops and grocery its all in your back yard. 10 out of 10 !!!\nThere is a genuine chicago style pizza place right behind Stephens Farms Chicago Style deep Dish indulge.  Enjoy. Thank you Stephens Farms.",
      "date": "2025-10-14",
      "title": "false"
    },
    {
      "id": "ec_ef1e79fac4af1681698b6cab",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "rating": "5",
      "name": "Ramakrishna Mallireddy",
      "text": "A Great Decision - Very Happy at Stephens Farm!\n\nWhen I was first considering moving to Stephens Farm about four months ago, I'll admit I was hesitant. I had read some negative reviews online, and the fact that there isn't a physical office on-site for immediate assistance was a concern.\n\nHowever, I decided to visit the property, and I was really impressed. The townhomes are new, modern, and in great condition, which made me feel that major maintenance problems would be unlikely. I decided to move forward, and I am so glad I did.\n\nSince moving in, I've had a couple of minor maintenance requests and one question regarding my rent account. This is where the service really shone for me. I reached out via email to our Resident Service Associate, Chelsea, and she has been absolutely fantastic. For every single inquiry, I received a helpful response either the same day or by the next morning. In an age of instant messaging, this responsive email communication has been efficient, professional, and all of my issues have been resolved promptly.\n\nMy initial worries were completely unnecessary, and I am very happy with my decision to live at Stephens Farm and am already planning to extend my lease.\n\nThat being said, it's helpful to have a complete picture. The community amenities are limited; the pool is quite small for the size of the community, and there is no gym. Prospective residents should also be aware that there are additional monthly fees for services like lawn care, which can add to the overall cost. While the total monthly expense might seem high to some.\n\nOverall, I would highly recommend this community, especially if you value a new, well-maintained home and responsive management.",
      "date": "2025-10-14",
      "title": "false"
    },
    {
      "id": "ec_23762c0883beb6a1c2ae73c3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "rating": "5",
      "name": "The Goat",
      "text": "★★★★★\nI’ve been helping my friends find a place to live as they move to the area, and Stephen’s Farm Crossing has been a great fit for short- or long-term stays. The spots look nice and are in a good location.\nChelsea was seriously the best part of it all. She took care of the whole application thing super smoothly, got all the paperwork sorted fast, and set up viewings whenever we needed. She answered every question right away and made sure everything went without a hitch. Couldn’t have asked for better help from her.\nDefinitely recommend if you’re new to the area.",
      "date": "2026-04-30",
      "title": "false"
    },
    {
      "id": "ec_353433587caa7b1f75682bd8",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "rating": "5",
      "name": "G Barnola",
      "text": "My wife and I have been very impressed with our new home, the neighborhood and the both the Quinn Residences portfolio manager, Leif and the resident services associate, Nitra. Both of them have been extremely knowledgeable and helpful with the move in process. We look forward to living in Stephens Farm. It’s a beautiful place and very convenient to  many things.",
      "date": "2026-06-23",
      "title": "false"
    },
    {
      "id": "ec_25ba57162d8a02d16544b371",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "rating": "5",
      "name": "Samantha Trace",
      "text": "We have had such a great experience, living here at Stephen’s  Farms. From the moment we lease the apartment to the neighbors and the maintenance staff, it’s all been a breath of fresh air for us. Most recently we had an unexpected outage in our garage and Rashad came same day to figure out what was going on and was able to fix it by the next morning so far our experience has been that the maintenance staff actually fixes things they don’t just put a Band-Aid over it. Which anyone knowing being in a rental community Band-Aids are the only type of fix maintenance people do if you’d like a nice place to live with great neighbors and great staff. Definitely give Stephen’s farm a chance.",
      "date": "2026-04-27",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [
    {
      "id": "custom_653c1bb5-889e-4607-9c3d-5b16ed187fb2",
      "question": "Application Fee",
      "answer": "$100 per person for all occupants over 18.",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_b82b1683-1dd3-4ec3-a9fa-57937c34a8e6",
      "question": "Administration Fee & Additional Charges",
      "answer": "A one-time administration fee of $350 is required at move-in. Please review the information below regarding additional charges and fees that may arise throughout your lease term.",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_8d9eaafb-ce36-48a0-84f3-617a1ab00f3f",
      "question": "Utility Billing Fee",
      "answer": "$11.99/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_dc9f7360-1f7d-43d9-9186-83e88211504d",
      "question": "Pet Fees",
      "answer": "Non-refundable pet fee of $300 for one pet ($500 for two pets). Pet rent $35/month per pet",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_52d6b0dd-03b2-4ab1-a20c-a7cc956c3c06",
      "question": "Concierge Package",
      "answer": "$10.95/month Bi-annual filter change Exterior pest control 24 hour maintenance response on emergencies Positive credit reporting",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_c69df444-576f-4765-9a27-c523c5b82336",
      "question": "Smart Home",
      "answer": "Smart Home Fee - $35/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_d0a96ba7-ecb8-4a44-bbf0-faa5d4b6ad95",
      "question": "Landscape Services",
      "answer": "Townhomes: $45/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_8c147603-f7e0-417e-8d4f-3ba298cf9c41",
      "question": "Occupancy Guidelines",
      "answer": "The maximum occupancy for Quinn properties is two (2) persons per bedroom, plus one (1) additional occupant per home. Occupancy standards may vary by region based on local city, county, and state laws.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_6edfb4f9-e360-4a75-96f3-c6eaf0126fcb",
      "question": "Application",
      "answer": "All adults, 18 years of age, or considered an adult under state law, are required to complete an application in its entirety. All occupants applying for the property must reside in the property. By acknowledging the terms and conditions outlined in the Quinn rental criteria, the Applicant confirms all information provided is true and accurate. Any falsification, fabrication, or untruthful answers and supporting documentation shall result in an automatic denial. Applicants are required, unless otherwise noted, to pay a $100.00 non-refundable application fee to authorize a background check and additional qualification processes; Properties may not be held off the market for greater than ten (10) days, unless a Quinn representative approves an extension. All applicants are required, unless otherwise specified, to pay a non-refundable $350 administration fee to secure a specific home and remove it from the market. All administration fees are non-refundable unless the application is declined. Upon Applicant approval, Leases are required to be signed within 24 hours of generation. In the event Lease is not signed within the 24-hour time Quinn may elect to cancel the application and place the home back on the market. All Applicants are required to provide valid identification. Non-US citizens applying to a home may be required to present information acknowledging the individual's right to live in the United States through the duration of the lease term. Approved applications are valid for thirty (30) days, after that time period, all Applicants must provide written consent for additional screening, credit checks, income verification, and re-qualification for a property managed by Quinn PM LLC. Any application that provides falsified or incorrect information may be subject to automatic disqualification. If an Applicant falsifies their application or supporting documentation, Quinn has the right to hold all deposits and fees paid to apply towards liquidated damages. DISCLAIMER: Rentgrow reports information about applicants in accordance with the applicable state and federal law. However, other federal, state or local laws and regulations may apply. This application, even if accepted, shall under no circumstances be considered a lease agreement between Applicant and Quinn, nor an offer to lease, and does not create a landlord/tenant relationship. No lease shall exist between an Applicant and Quinn unless and until the parties enter a fully executed Lease Agreement conditioned on the Applicant paying all required fees, security deposits, and rent. At Quinn PM LLC's sole discretion, Quinn PM LLC reserves the right to cancel an approved application, and refuse occupancy to any applicant(s) who disrupts or interferes with Landlord's business operations, or communicates with Landlord, Landlord's agents, or their employees in an unreasonable, discourteous, rude, or hostile manner.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_53ba9e87-1f86-43dd-adca-9ca8db2899bd",
      "question": "Guarantors",
      "answer": "Guarantors may be accepted to support an application and must complete all required application and screening processes. Applicants who do not independently meet qualification criteria may also have the option to utilize a third-party lease guarantee program through TheGuarantors, which does not add an additional occupant or leaseholder.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_917de672-5688-4680-8037-f69b9f73e3bc",
      "question": "Income",
      "answer": "Income Requirements: Household income requirements are based upon the market and other qualification factors within the application process. In-State Income Verification: Proof of income being made in the state where you are wishing to rent a home is required. Examples include, but are not limited to, state taxes shown on your pay statements, an offer letter or transfer letter confirming you are beginning a new role in that state, or proof that you are a remote employee. Job Transfer/New Role: Applicants with an offer of employment or transfer of role from their existing employer are required to provide an Offer Letter or Transfer Letter on employer letterhead confirming terms of compensation and start date. The letter should be signed and dated by the offeror. Contract-Based Employment: At select communities, an additional income verification option may be available for applicants working on a contract basis. This may include providing a notarized letter on company letterhead confirming income from Human Resources, Payroll, the business owner, or a company officer. Additional documentation may be required to verify the stated income. Additional Income Sources: Social Security Benefits, Child Support, Alimony, Disability, Retirement, Pensions, VA Benefits and complete Bank Statements are accepted. Items containing redacted or otherwise altered information are subject to additional verification and/or denial. Additional Documentation: Quinn may request additional proof of income if the documents provided are insufficient. False or Altered Documentation: Applicants who provide any false, counterfeit, or other fake documentation are subject to denial, even if discovered after approval. Any falsified documents will result in a denial.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_a74f75ca-8ec5-47de-824e-2eb181608183",
      "question": "Security Deposit",
      "answer": "An applicant's security deposit is determined by the score of the applicant and may result in an increased security deposit for approval.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_5e42f4ad-9703-497d-8759-13f8be88dbed",
      "question": "Credit Report",
      "answer": "All applicant's credit history enters a scoring model to determine qualifications for each application. The SafeRent Score is determined from an analysis of information found in each applicant's consumer credit report, application, and previous rental histories (if applicable). Consumer reports may include but are not limited to payment history, bankruptcies, number and type of accounts, collection activity, outstanding debt and credit inquiries. In addition, the scoring process includes income-to-rent ratio, eviction records, and subprime credit records. Current Open Bankruptcies (Chapter 7 or 13) will result in an automatic denial. Applicants are subject to further verification at the request of a Quinn representative. For applications in the state of South Carolina: Applicant(s) does hereby consent upon completion and meeting the criteria of a credit and rental history screening, a criminal background report will be processed by Quintasen Holdings, LLC to complete screening of the consumer information report.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_38b30add-b768-4ee4-a452-9dc693661ff7",
      "question": "Rental History",
      "answer": "Prior Evictions, filed or enforced, may result in an automatic denial of the application. Any outstanding debt or judgment owed to any prior landlord may result in a denial. Quinn may request rental verification if rental history cannot be verified.",
      "category": "Leasing History",
      "source": "custom"
    },
    {
      "id": "custom_843729e4-3c17-43ba-8512-4ce509cf7a48",
      "question": "Criminal History",
      "answer": "Each Applicant is subject to a criminal background check. Criminal background screening is broken into the following categories 1) Crimes Against Persons, 2) Property, and 3) Society. Criminal histories presented through applicant screening reports pertaining to weapons, drugs, violence, or any other act that poses a threat to household, neighborhood, vendors, Quinn employees, or the physical property itself, may result in a denial. Criminal history will be assessed on the risk to persons or property by an applicant including but not limited to the type of crime; the severity of the crime; circumstance of the crime; and the length of time since the crime occurred. Denied Applicants may dispute any wrongful record claims by contacting Screening Works and following the process as outlined in their action letter and Screening Works. Criminal background screening is also governed by federal, state or local laws which regulate Quinn's screening processes. An Office of Foreign Assets Control (OFAC) search is completed for each Applicant. If Applicant appears on the OFAC list, the application will be denied.",
      "category": "Leasing History",
      "source": "custom"
    },
    {
      "id": "custom_a75b07ba-6173-478a-8909-365684733210",
      "question": "Pets",
      "answer": "Pet Screening: Mandatory for all applicants before move-in. Pet Restrictions: Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, and American Bulldog, or any crossbreeds of these. Maximum weight limit of 100 pounds per pet. No more than two (2) pets allowed unless written approval is obtained from Quinn Property Management. Fees: Non-refundable pet fee of $300 for one pet; $500 for up to two pets. Monthly pet rent of $35 per pet. Prohibited Animals: Dangerous or poisonous animals and exotic pets are not permitted. Fish Tanks: Limited to 20 gallons. No pet fee or pet rent required for fish. Assistive Animals: Animals assisting persons with disabilities are exempt from these restrictions and are not considered pets. Vaccinations and Registrations: All pets must have up-to-date vaccinations and current state, city, and county registrations. Visiting Animals: No visiting animals allowed under any circumstances.",
      "category": "Pets & Animals",
      "source": "custom"
    },
    {
      "id": "custom_9b09e66d-886e-46b0-a1bd-3592325a1bb5",
      "question": "Assistance Animals",
      "answer": "No Cost - Pet screening is mandatory as part of the application process prior to move in with a 2-5 business day approval turnaround time. Assistive Animals for persons with disabilities are not considered to be pets and are not subject to the pet restrictions bestowed in this section.",
      "category": "Pets & Animals",
      "source": "custom"
    },
    {
      "id": "custom_e5c60537-25f8-4941-b46f-566f7a4bd5da",
      "question": "Vehicles",
      "answer": "No more than four (4) vehicles are permitted on the Premises. Vehicles must be operational and have current and valid registration based upon state law. Additional HOA restrictions may apply to the number of vehicles, commercial vehicles and allowed parking locations. If your home is contained in an HOA review the HOA's restrictive covenants for more information regarding vehicle guidelines.",
      "category": "Vehicles",
      "source": "custom"
    },
    {
      "id": "custom_402262d3-509f-478e-8f8e-bfeeb6b20280",
      "question": "Renters Insurance",
      "answer": "To alleviate concerns and help you protect what matters most we have partnered with Assurant, a preferred insurance provider, to make the process of protecting your home and property seamless. We know how busy life can be, and we wanted to provide you an option that makes the selection of an insurance policy simple, while meeting your lease requirements. Please visit this page for more information on renters insurance requirements.",
      "category": "Renters Insurance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [
    {
      "id": "ec_b20a31580a810bb796701eb5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "yardi",
      "external_id": "2358323",
      "pet_type": "all",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 100,
      "deposit": 0,
      "fee": 350,
      "monthly_rent": 35,
      "description": "false",
      "restrictions": "Contact Management"
    },
    {
      "id": "ec_fd2349eb1a41cadbf1f340ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "yardi",
      "external_id": "2362863",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 350,
      "monthly_rent": 35,
      "description": "false",
      "restrictions": "false"
    },
    {
      "id": "ec_b8a17c6e53d5b1c2fd9ee865",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "yardi",
      "external_id": "2362862",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 100,
      "deposit": 0,
      "fee": 350,
      "monthly_rent": 35,
      "description": "false",
      "restrictions": "false"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0abe0-a174-7629-9013-4347eb75c33c",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Stephens Farm Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639"
    },
    {
      "lead_collector_id": "01a0abe0-a1ed-735f-a965-215a55ab6a79",
      "lead_source": "LANDING_PAGE",
      "name": "Stephens Farm Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "generator",
      "page_item_url": "luxury-apartments-in-unit-laundry-holly-springs",
      "search_query": "luxury apartments with in-unit laundry in Holly Springs",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover luxury living with in-unit laundry options at Stephens Farm in Holly Springs. Enjoy top-notch amenities and a convenient lifestyle.",
      "page_copy": "At Stephens Farm, we redefine luxury apartment living in Holly Springs. Nestled in a vibrant community, our apartments boast in-unit laundry facilities for the utmost convenience. Feel at home in stylish spaces featuring granite countertops, spacious closets, and modern finishes that exude luxury. Our pet-friendly community also offers amenities such as a refreshing pool and a BBQ grill, perfect for those relaxing weekends.\n\nLocated in the charming Wake County, Stephens Farm provides more than just a comfortable living space. From a well-equipped playground for the little ones to beautifully maintained communal areas, enjoy the perfect blend of elegance and functionality. Experience the luxury of having in-unit laundry in our apartments, ensuring a seamless and stress-free lifestyle right in the heart of Holly Springs.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with In-Unit Laundry Available",
      "seo_description": "Explore luxury apartments with in-unit laundry at Stephens Farm, Holly Springs. Enjoy modern amenities including a pool and spacious closets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "generator",
      "page_item_url": "smart-home-tech-apartments-wake-county",
      "search_query": "smart home technology apartments Wake County",
      "category": "Amenity",
      "h1_title": "Smart Home Technology Apartments",
      "h2_subtitle": "Experience cutting-edge smart home technology in apartments at Stephens Farm, located in Wake County. Enjoy convenience like never before.",
      "page_copy": "Welcome to Stephens Farm, where modern living meets smart home technology in the heart of Wake County. Our apartments are equipped with state-of-the-art smart features designed to enhance your everyday life. From controlling your home's temperature remotely to managing security systems at the touch of a button, our smart home technology ensures peace of mind and modern convenience.\n\nIn addition to advanced tech offerings, our community provides a range of luxury amenities, including a sparkling pool, playground, and BBQ grill perfect for social gatherings. Each apartment features granite countertops, in-unit laundry, and spacious closets, marrying style with functionality. Explore exceptional living where innovation and comfort coalesce at Stephens Farm, your ideal home in vibrant Wake County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smart Home Tech Apartments in Wake County",
      "seo_description": "Discover smart home technology apartments at Stephens Farm, Wake County. Enjoy modern living with advanced features and luxury amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "generator",
      "page_item_url": "playground-apartments-holly-springs",
      "search_query": "families love playground apartments Holly Springs NC",
      "category": "Amenity",
      "h1_title": "Families Love Our Playground Apartments",
      "h2_subtitle": "Families adore the playground-equipped apartments at Stephens Farm in Holly Springs, NC. A perfect community for kids and parents alike.",
      "page_copy": "At Stephens Farm, we understand that families prioritize communities with fun and engaging amenities. Located in Holly Springs, NC, our apartments offer a fantastic playground, making them an ideal choice for families. The secure and well-maintained play area ensures kids have a safe space to enjoy while fostering a sense of community among neighbors.\n\nBeyond the playground, our family-friendly apartments include spacious closets and modern kitchens with granite countertops, perfect for growing families. Enjoy a relaxing dip in the pool or make delightful weekend memories using our BBQ grill facilities. Stephens Farm is a community where convenience meets family-friendly living, offering everything you need in beautiful Holly Springs.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Families Love Playground Apartments in Holly Springs",
      "seo_description": "Discover why families love the playground apartments at Stephens Farm, Holly Springs, NC. Perfect for kids and family activities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-dog-park-27540",
      "search_query": "pet-friendly apartments with dog park near 27540",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Dog Park",
      "h2_subtitle": "Discover pet-friendly living with a dog park near 27540 at Stephens Farm. Perfect for pet owners seeking a welcoming community.",
      "page_copy": "Stephens Farm is the perfect destination for pet lovers seeking comfortable accommodations in Holly Springs. Our pet-friendly apartments feature a nearby dog park, creating a haven for your furry friends right near the 27540 area. Whether it's playtime or a casual stroll, the dog park offers a safe and enjoyable environment for pets to exercise and socialize.\n\nLocated conveniently in Wake County, our community doesn't just cater to pets. Residents enjoy premium amenities like spacious closets, granite countertops, and modern kitchen designs. A relaxing pool and convenient BBQ grill add further appeal, ensuring a well-rounded living experience. For those with pets, Stephens Farm provides an idyllic setting blending comfort, convenience, and pet-friendly features.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apts with Dog Park Near 27540",
      "seo_description": "Enjoy pet-friendly apartments with a nearby dog park at Stephens Farm, Holly Springs, near 27540. Perfect place for pet lovers and families.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "generator",
      "page_item_url": "apartments-pool-granite-countertops-holly-springs",
      "search_query": "apartments with pool and granite countertops Holly Springs",
      "category": "Amenity",
      "h1_title": "Pool and Granite Countertop Apartments",
      "h2_subtitle": "Find apartments with a pool and modern granite countertops in Holly Springs at Stephens Farm. Experience luxury living at its best.",
      "page_copy": "Stephens Farm in Holly Springs offers the perfect blend of luxury and comfort with our premium amenities. Our apartments feature elegant granite countertops, bringing style and functionality to your kitchen. Whether you're preparing a quick meal or hosting friends, these high-quality finishes enhance your living experience.\n\nAdditionally, residents can unwind at our sparkling pool, a key highlight of community life, perfect for relaxation and socializing. Our property also includes other amenities like spacious closets and a playground, making it ideal for families and individuals alike. Discover elevated living in Holly Springs at Stephens Farm, where each detail is designed with you in mind.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with Pool & Granite Countertops in Holly Springs",
      "seo_description": "Explore Stephens Farm's apts in Holly Springs featuring a pool and granite countertops. Luxurious living in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-holly-springs",
      "search_query": "three bedroom apartments holly springs nc",
      "category": "Floorplan",
      "h1_title": "Spacious Three Bedroom Apartments",
      "h2_subtitle": "Explore our three bedroom apartments in Holly Springs, NC at Stephens Farm. Perfect for families and roommates seeking ample space and comfort.",
      "page_copy": "Experience the best of Holly Springs, NC living with our spacious three bedroom apartments at Stephens Farm. Tailored for families and roommates, these apartments provide ample space, allowing everyone to have their own personal haven. With roomy layouts and plenty of closet space, organizing and settling in is a breeze.\n\nApart from generous living areas, our community offers luxurious granite countertops in the kitchens and a range of amenities like a community pool and playground. These features provide both comfort and recreational options right at your doorstep. Located in the vibrant Holly Springs community, Stephens Farm is the ideal place for those seeking a well-rounded lifestyle with plenty of room to grow.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Holly Springs, NC",
      "seo_description": "Discover spacious three bedroom apartments at Stephens Farm in Holly Springs, NC. Ideal for families or roommates seeking comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "generator",
      "page_item_url": "four-bedroom-rentals-wake-county",
      "search_query": "four bedroom rentals wake county",
      "category": "Floorplan",
      "h1_title": "Spacious Four Bedroom Rentals in Wake County",
      "h2_subtitle": "Discover the ideal four bedroom rentals in Wake County at Stephens Farm. Perfect for larger families and groups seeking comfort and ample space.",
      "page_copy": "Stephens Farm offers exceptional four bedroom rentals in Wake County, designed to provide ample living space for larger families or groups. Our apartments blend comfort with modern features, ensuring a practical and stylish home environment. The generous floor plans allow for flexibility in room arrangement, perfect for crafting personalized living spaces.\n\nResidents enjoy exclusive access to top-tier amenities including granite countertops that elevate kitchen aesthetics and functionality, a refreshing pool for leisure, and spacious closets for all your storage needs. Situated in Holly Springs, our community not only offers comfort and space but also a convenient location within Wake County, making everyday living a breeze. Whether you're seeking room for a growing family or a shared living arrangement, Stephens Farm is the perfect choice.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Four Bedroom Rentals in Wake County",
      "seo_description": "Explore spacious four bedroom rentals at Stephens Farm in Wake County, offering luxury features and ample space for families and groups.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "generator",
      "page_item_url": "apartments-near-wake-tech-western-wake-campus",
      "search_query": "apartments near Wake Technical Community College Western Wake Campus Holly Springs",
      "category": "School",
      "h1_title": "Apartments Near Wake Tech Western Wake",
      "h2_subtitle": "Find the perfect apartment near Wake Technical Community College's Western Wake Campus at Stephens Farm in Holly Springs, NC.",
      "page_copy": "Located just a short drive from Wake Technical Community College's Western Wake Campus, Stephens Farm offers convenient and comfortable apartment living in Holly Springs. Our community provides an ideal setting for students and professionals seeking proximity to education and work.\n\nBeyond a great location, residents can enjoy luxurious features like stunning granite countertops, spacious closets, and access to our sparkling pool and playground. Whether you're balancing classes or enjoying local amenities, our apartments provide a balance of convenience and modern living, making Stephens Farm an excellent choice for those looking to be near Wake Tech's Western Wake Campus.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Wake Tech Western Wake Campus",
      "seo_description": "Discover apts near Wake Tech's Western Wake Campus at Stephens Farm in Holly Springs, offering convenience and luxury amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "generator",
      "page_item_url": "apartments-near-rex-holly-springs-hospital",
      "search_query": "apartments near Rex Holly Springs Hospital NC",
      "category": "Hospital",
      "h1_title": "Close Apartments to Rex Holly Springs Hospital",
      "h2_subtitle": "Discover your ideal home near Rex Holly Springs Hospital at Stephens Farm. Perfect for healthcare professionals and visitors seeking nearby accommodations.",
      "page_copy": "Stephens Farm offers comfortable and modern living just minutes from Rex Holly Springs Hospital, NC. Ideal for healthcare professionals and families seeking convenient access to the hospital, our apartments provide a serene home base in the heart of Holly Springs.\n\nResidents enjoy high-end features such as granite countertops and spacious closets, alongside community amenities like a refreshing pool and a playground for younger family members. Whether you’re working long hours or visiting loved ones, our proximity to Rex Holly Springs Hospital ensures that you are both connected and cared for in a welcoming community environment.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Rex Holly Springs Hospital",
      "seo_description": "Explore apartments close to Rex Holly Springs Hospital at Stephens Farm, offering modern amenities and a prime location in Holly Springs, NC.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "generator",
      "page_item_url": "apartments-near-pleasant-park-holly-springs",
      "search_query": "apartments near Pleasant Park Holly Springs",
      "category": "Park",
      "h1_title": "Live Near Pleasant Park in Holly Springs",
      "h2_subtitle": "Find your new home near Pleasant Park at Stephens Farm, where convenience meets modern living in Holly Springs, NC.",
      "page_copy": "Located just a stone's throw from Pleasant Park, Stephens Farm offers exceptional apartment living in Holly Springs. Perfect for those who enjoy outdoor activities and community events, our apartments place you within easy reach of one of the town's most beloved recreational spaces.\n\nOur residents revel in modern amenities like elegant granite countertops, roomy closets, and a community pool perfect for relaxing after a day at the park. Whether you're walking the trails or attending a sports event, living near Pleasant Park enhances your lifestyle while enjoying the comfort and luxury of home at Stephens Farm.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Pleasant Park in Holly Springs",
      "seo_description": "Discover apartments close to Pleasant Park in Holly Springs at Stephens Farm. Enjoy modern amenities and a perfect location for outdoor enthusiasts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "generator",
      "page_item_url": "stephens-farm-near-north-main-athletic-complex",
      "search_query": "Stephens Farm close to North Main Athletic Complex",
      "category": "Park",
      "h1_title": "Stephens Farm Near North Main Athletic",
      "h2_subtitle": "Experience vibrant apartment living at Stephens Farm, conveniently close to North Main Athletic Complex in Holly Springs, NC.",
      "page_copy": "Stephens Farm offers a perfect home base for those who frequent the North Main Athletic Complex. Located in Holly Springs, our community provides easy access to sports and events while offering residents a tranquil living environment.\n\nEnjoy luxurious features such as granite countertops and spacious closets, and unwind with community amenities like a refreshing pool and a fun playground. Whether you're attending a game or playing on the fields, living close to the North Main Athletic Complex at Stephens Farm enhances your active lifestyle with comfort and convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Stephens Farm by North Main Athletic Complex",
      "seo_description": "Live at Stephens Farm near North Main Athletic Complex in Holly Springs. Enjoy luxury amenities and proximity to local sports activities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "generator",
      "page_item_url": "harris-lake-county-park-nearby-apartment-living",
      "search_query": "Harris Lake County Park nearby apartment living",
      "category": "Park",
      "h1_title": "Apartment Living Near Harris Lake County Park",
      "h2_subtitle": "Embrace nature with apartment living near Harris Lake County Park at Stephens Farm, offering modern comforts in Holly Springs, NC.",
      "page_copy": "At Stephens Farm, experience the perfect blend of nature and modern living with Harris Lake County Park just a short drive away. Ideal for outdoor lovers, our community provides convenient access to scenic hiking trails, fishing spots, and picnic areas.\n\nOur apartments offer luxurious touches like granite countertops and expansive closets, combined with amenities such as a refreshing pool and BBQ grill. Whether you’re exploring the park or enjoying a relaxed evening at home, living near Harris Lake County Park means adventure and comfort await you every day at Stephens Farm.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apt Living Near Harris Lake County Park",
      "seo_description": "Enjoy apartment living near Harris Lake County Park at Stephens Farm. Experience nature, modern amenities, and adventure in Holly Springs, NC.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167639",
      "source": "generator",
      "page_item_url": "bass-lake-park-proximity-apartments-wake-county",
      "search_query": "Bass Lake Park proximity apartments Wake County",
      "category": "Park",
      "h1_title": "Apartments Near Bass Lake Park, Wake County",
      "h2_subtitle": "Discover apartment living near Bass Lake Park in Wake County at Stephens Farm, offering modern amenities just minutes away.",
      "page_copy": "Stephens Farm is ideally situated for those who appreciate the serene environment of Bass Lake Park in Wake County. Our proximity to the park offers residents the perfect escape into nature while still enjoying the conveniences of modern apartment living.\n\nOur community features a variety of amenities, including spacious closets, a community pool, and a BBQ grill area, making it easy for you to entertain and relax. Embrace the balance of outdoor adventures and comfort within our beautifully designed apartments, and enjoy all that Bass Lake Park has to offer just moments from your doorstep.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bass Lake Park Proximity Apartments in Wake",
      "seo_description": "Find apartments near Bass Lake Park in Wake County at Stephens Farm. Enjoy modern living and nature's beauty in Holly Springs, NC.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12977247729"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-P8S6S6QX"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "57156624034"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/5evedx92wqo"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/144bdc67-edeb-4372-9afc-003ac69921f8/units"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "ce8e1268-c17f-11ef-8846-0b601f894899"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "dba41761-2900-497b-8de7-41d7628b5018"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "866-974-0660"
    },
    {
      "ID": "custom_paid_social_tracking_phone_number",
      "type": "STRING",
      "value": "833-778-4730"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_repli_id": "12977247729",
  "custom_google_gtm_id": "GTM-P8S6S6QX",
  "custom_rollout_phase": "Phase 2",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "full_stack",
  "custom_hubspot_company_id": "57156624034",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/5evedx92wqo",
  "custom_self_guided_tour_url": "https://selftournow.com/property/144bdc67-edeb-4372-9afc-003ac69921f8/units",
  "custom_website_subscription": "custom",
  "custom_eliseai_building_token": "ce8e1268-c17f-11ef-8846-0b601f894899",
  "custom_eliseai_organization_id": "dba41761-2900-497b-8de7-41d7628b5018",
  "custom_ppc_tracking_phone_number": "866-974-0660",
  "custom_paid_social_tracking_phone_number": "833-778-4730",
  "custom_audioeye_site_id": "2b3b517e-b9de-4d1c-80bd-e46b418b8fd6",
  "custom_audioeye_site_hash": "caecdf4ec16d5d96043a1aac9d775af3"
};

export const generatedAt = '2026-10-29T18:33:38.109Z';
